export default {
    "en": {
        "imageUpscaler": {
            "title": "Free AI Image Upscaler - Upscale to 4K | WeryAI",
            "description": "Upscale low-res images to 2x, 4x, or 4K with AI. Fix blurry photos and remove noise in one click. Free credits on signup, no credit card needed.",
            "keywords": "ai image upscaler, photo enhancer, upscale image to 4k, unblur image, fix pixelated photo, increase image resolution, WeryAI",
            "og_title": "Free AI Image Upscaler - Upscale to 4K | WeryAI",
            "og_description": "Upscale low-res images to 2x, 4x, or 4K with AI. Fix blurry photos and remove noise in one click. Free credits on signup, no credit card needed.",
            "twitter_title": "Free AI Image Upscaler - Upscale to 4K | WeryAI",
            "twitter_description": "Upscale low-res images to 2x, 4x, or 4K with AI. Fix blurry photos and remove noise in one click. Free credits on signup, no credit card needed.",
            "page": {
                "title1": "Free AI Image Upscaler & Enhancer",
                "title2": "Turn pixelated, blurry, or old photos into high-definition masterpieces. WeryAI uses advanced AI to upscale image resolution by up to 400% (4K) while recovering lost details, fixing noise, and restoring faces in old family portraits.",
                "faq": [
                    {
                        "question": "Can I upscale low-res images for printing?",
                        "answer": "Yes! WeryAI increases the resolution (pixel count) of your image up to 4K, making it suitable for high-quality printing on posters, canvas, or marketing materials."
                    },
                    {
                        "question": "How does AI old photo restoration work?",
                        "answer": "The AI analyzes the damaged or blurry parts of the old photo and uses deep learning to predict and reconstruct facial details, textures, and backgrounds, effectively \"healing\" the image. Want to restore old photos? Try our <a href=\"/photo-restoration\">Photo Restoration</a> tool."
                    },
                    {
                        "question": "What formats are supported?",
                        "answer": "We support common formats like JPG, PNG, and WEBP. The output will be a high-quality PNG or JPG."
                    },
                    {
                        "question": "Does it work on anime/cartoons?",
                        "answer": "Yes. Our AI excels at upscaling anime and illustrations (waifu2x style), keeping lines sharp and colors vibrant without artifacts."
                    },
                    {
                        "question": "Can I use WeryAI AI Image Upscaler for free?",
                        "answer": "Yes. New users get free credits on signup with no credit card required. You can also earn more free credits through daily check-in, completing tasks, and inviting friends, so you can keep using the tool without an upfront payment."
                    }
                ]
            },
            "faq": [
                {
                    "question": "Can I upscale low-res images for printing?",
                    "answer": "Yes! WeryAI increases the resolution up to 4K, making images suitable for high-quality printing."
                },
                {
                    "question": "How does AI old photo restoration work?",
                    "answer": "The AI analyzes damaged areas and reconstructs facial details and textures using deep learning to heal the image."
                },
                {
                    "question": "Does it work on anime?",
                    "answer": "Yes. Our AI excels at upscaling anime and illustrations, keeping lines sharp without artifacts."
                }
            ],
            "feature_title1": "Lossless Upscaling to 4K",
            "feature_desc1": "Print-Ready Quality: Need to print a small image? Upscale it to 4K or 8K without losing quality. Perfect for posters, e-commerce product shots, and wallpapers.",
            "feature_title2": "Smart Denoise & Deblur",
            "feature_desc2": "Fix Night Shots: Remove digital noise and grain from low-light photos. Sharpen blurry edges instantly to make your photos look crisp and professional.",
            "feature_title3": "Old Photo Restoration",
            "feature_desc3": "Revive Memories: Have old, damaged, or black-and-white photos? Our AI creates new pixels to repair scratches, sharpen faces, and bring clarity back to your treasured memories.",
            "howto": {
                "name": "How to Upscale Image to 4K",
                "step1": {
                    "name": "Upload Photo",
                    "text": "Upload your low-resolution or blurry image to WeryAI Upscaler."
                },
                "step2": {
                    "name": "Select Scale",
                    "text": "Choose your desired upscale factor (e.g., 2x, 4x)."
                },
                "step3": {
                    "name": "Enhance",
                    "text": "Click 'Create'. The AI will process the image, instantly improving resolution and clarity."
                }
            }
        }
    },
    "zh": {
        "imageUpscaler": {
            "title": "免费 AI 图片放大器 - 放大至 4K | WeryAI",
            "description": "使用 WeryAI 的免费 AI 图像增强器，即时将低分辨率图像放大至 2 倍、4 倍和 4K。修复模糊照片、去除噪点，在线修复老照片。无损质量。",
            "keywords": "ai图像增强器, 照片增强器, 图像放大至4k, 图像去模糊, 老照片修复, 修复像素化照片, 提高图像分辨率",
            "og_title": "免费 AI 图片放大器 - 放大至 4K | WeryAI",
            "og_description": "使用 WeryAI 的免费 AI 图像增强器，即时将低分辨率图像放大至 2 倍、4 倍和 4K。修复模糊照片、去除噪点，在线修复老照片。无损质量。",
            "twitter_title": "免费 AI 图片放大器 - 放大至 4K | WeryAI",
            "twitter_description": "使用 WeryAI 的免费 AI 图像增强器，即时将低分辨率图像放大至 2 倍、4 倍和 4K。修复模糊照片、去除噪点，在线修复老照片。无损质量。",
            "page": {
                "title1": "免费 AI 图像增强器和放大器",
                "title2": "将像素化、模糊或老照片转换为高清杰作。WeryAI 使用先进的 AI 技术将图像分辨率提升高达 400%（4K），同时恢复丢失的细节、修复噪点并修复老家庭肖像中的人脸。",
                "faq": [
                    {
                        "question": "我可以放大低分辨率图像用于打印吗？",
                        "answer": "可以！WeryAI 可以将图像的分辨率（像素数）提升至 4K，使其适合在海报、画布或营销材料上进行高质量打印。"
                    },
                    {
                        "question": "AI 老照片修复是如何工作的？",
                        "answer": "AI 会分析老照片中受损或模糊的部分，使用深度学习来预测和重建面部细节、纹理和背景，有效地\"修复\"图像。"
                    },
                    {
                        "question": "支持哪些格式？",
                        "answer": "我们支持常见格式，如 JPG、PNG 和 WEBP。输出将是高质量的 PNG 或 JPG。"
                    },
                    {
                        "question": "它适用于动漫/卡通吗？",
                        "answer": "是的。我们的 AI 擅长放大动漫和插画（waifu2x 风格），保持线条清晰、色彩鲜艳，无伪影。"
                    },
                    {
                        "question": "我可以免费使用 WeryAI AI 图片放大器吗？",
                        "answer": "可以。新用户注册即可获得免费积分，无需绑定信用卡。您还可以通过每日签到、完成任务和邀请好友获得更多免费积分，因此可以持续使用而无需预付费用。"
                    }
                ]
            },
            "faq": [
                {
                    "question": "我可以放大低分辨率图像用于打印吗？",
                    "answer": "可以！WeryAI 可以将分辨率提升至 4K，使图像适合高质量打印。"
                },
                {
                    "question": "AI 老照片修复是如何工作的？",
                    "answer": "AI 会分析受损区域，使用深度学习重建面部细节和纹理，以修复图像。"
                },
                {
                    "question": "它适用于动漫吗？",
                    "answer": "是的。我们的 AI 擅长放大动漫和插画，保持线条清晰，无伪影。"
                }
            ],
            "feature_title1": "无损放大至 4K",
            "feature_desc1": "打印就绪质量：需要打印小图像吗？将其放大至 4K 或 8K 而不损失质量。非常适合海报、电商产品照片和壁纸。",
            "feature_title2": "智能降噪和去模糊",
            "feature_desc2": "修复夜景照片：去除低光照片中的数字噪点和颗粒。即时锐化模糊边缘，让您的照片看起来清晰专业。",
            "feature_title3": "老照片修复",
            "feature_desc3": "重拾回忆：有老旧、受损或黑白照片吗？我们的 AI 创建新像素来修复划痕、锐化人脸，并为您珍贵的回忆带来清晰度。",
            "howto": {
                "name": "如何将图片无损放大至 4K",
                "step1": {
                    "name": "上传照片",
                    "text": "将您的低分辨率或模糊图片上传到 WeryAI 放大器。"
                },
                "step2": {
                    "name": "选择比例",
                    "text": "选择您想要的放大倍数（例如 2x、4x）。"
                },
                "step3": {
                    "name": "增强",
                    "text": "点击“创建”。AI 将处理图片，瞬间提升分辨率和清晰度。"
                }
            }
        }
    },
    "ja": {
        "imageUpscaler": {
            "title": "無料 AI 画像拡大 - 4K に拡大 | WeryAI",
            "description": "WeryAI の無料 AI 画像強化ツールで、低解像度画像を 2 倍、4 倍、4K に即座に拡大。ぼやけた写真を修正し、ノイズを除去し、古い家族写真をオンラインで復元。ロスレス品質。",
            "keywords": "ai画像拡大ツール, 写真強化ツール, 画像を4kに拡大, 画像のぼかし除去, 古い写真復元, ピクセル化した写真を修正, 画像解像度を向上",
            "og_title": "無料 AI 画像拡大 - 4K に拡大 | WeryAI",
            "og_description": "WeryAI の無料 AI 画像強化ツールで、低解像度画像を 2 倍、4 倍、4K に即座に拡大。ぼやけた写真を修正し、ノイズを除去し、古い家族写真をオンラインで復元。ロスレス品質。",
            "twitter_title": "無料 AI 画像拡大 - 4K に拡大 | WeryAI",
            "twitter_description": "WeryAI の無料 AI 画像強化ツールで、低解像度画像を 2 倍、4 倍、4K に即座に拡大。ぼやけた写真を修正し、ノイズを除去し、古い家族写真をオンラインで復元。ロスレス品質。",
            "page": {
                "title1": "無料 AI 画像拡大ツール & 強化ツール",
                "title2": "ピクセル化、ぼやけた、または古い写真を高解像度の傑作に変換。WeryAI は高度な AI を使用して、画像解像度を最大 400%（4K）まで拡大し、失われたディテールを回復し、ノイズを修正し、古い家族の肖像画の顔を復元します。",
                "faq": [
                    {
                        "question": "低解像度画像を印刷用に拡大できますか？",
                        "answer": "はい！WeryAI は画像の解像度（ピクセル数）を 4K まで向上させ、ポスター、キャンバス、またはマーケティング資料での高品質印刷に適しています。"
                    },
                    {
                        "question": "AI 古い写真復元はどのように機能しますか？",
                        "answer": "AI は古い写真の損傷またはぼやけた部分を分析し、ディープラーニングを使用して顔のディテール、テクスチャ、背景を予測および再構築し、効果的に画像を「修復」します。"
                    },
                    {
                        "question": "どの形式がサポートされていますか？",
                        "answer": "JPG、PNG、WEBP などの一般的な形式をサポートしています。出力は高品質の PNG または JPG になります。"
                    },
                    {
                        "question": "アニメ/漫画で動作しますか？",
                        "answer": "はい。当社の AI はアニメとイラスト（waifu2x スタイル）の拡大に優れており、アーティファクトなしで線をシャープに、色を鮮やかに保ちます。"
                    },
                    {
                        "question": "WeryAIAI画像拡大ツールは無料で使用できますか？",
                        "answer": "はい。新規ユーザーは登録時に無料クレジットを受け取れ、クレジットカードも不要です。さらに、毎日のチェックイン、タスク完了、友達招待でも無料クレジットを獲得できるため、前払いなしで使い続けられます。"
                    }
                ]
            },
            "faq": [
                {
                    "question": "低解像度画像を印刷用に拡大できますか？",
                    "answer": "はい！WeryAI は解像度を 4K まで向上させ、画像を高品質印刷に適したものにします。"
                },
                {
                    "question": "AI 古い写真復元はどのように機能しますか？",
                    "answer": "AI は損傷した領域を分析し、ディープラーニングを使用して顔のディテールとテクスチャを再構築し、画像を修復します。"
                },
                {
                    "question": "アニメで動作しますか？",
                    "answer": "はい。当社の AI はアニメとイラストの拡大に優れており、アーティファクトなしで線をシャープに保ちます。"
                }
            ],
            "feature_title1": "ロスレス 4K 拡大",
            "feature_desc1": "印刷準備完了の品質：小さな画像を印刷する必要がありますか？品質を失うことなく 4K または 8K に拡大します。ポスター、eコマース製品写真、壁紙に最適です。",
            "feature_title2": "スマートノイズ除去 & ぼかし修正",
            "feature_desc2": "夜景写真を修正：低照度写真からデジタルノイズとグレインを除去します。ぼやけたエッジを即座にシャープにして、写真を鮮明でプロフェッショナルに見せます。",
            "feature_title3": "古い写真復元",
            "feature_desc3": "思い出を蘇らせる：古い、損傷した、または白黒の写真がありますか？当社の AI は新しいピクセルを作成して傷を修復し、顔をシャープにし、大切な思い出に明確さを取り戻します。",
            "howto": {
                "name": "画像を4Kにアップスケールする方法",
                "step1": {
                    "name": "写真をアップロード",
                    "text": "WeryAI Upscalerに低解像度またはぼやけた画像をアップロードします。"
                },
                "step2": {
                    "name": "スケールを選択",
                    "text": "希望のアップスケール倍率（例：2倍、4倍）を選択します。"
                },
                "step3": {
                    "name": "高画質化",
                    "text": "「作成」をクリックします。AIが画像を処理し、解像度と鮮明さを瞬時に向上させます。"
                }
            }
        }
    },
    "ko": {
        "imageUpscaler": {
            "title": "무료 AI 이미지 업스케일러 - 4K로 확대 | WeryAI",
            "description": "WeryAI의 무료 AI 이미지 향상기로 저해상도 이미지를 2배, 4배, 최대 4K까지 즉시 확대하세요. 흐릿한 사진을 선명하게 하고 노이즈를 제거하며 오래된 가족 사진을 온라인에서 복원합니다. 무손실 품질.",
            "keywords": "AI 이미지 업스케일러, 사진 향상, 이미지 4K 업스케일, 흐림 제거, 오래된 사진 복원, 픽셀 깨짐 수정, 이미지 해상도 올리기",
            "og_title": "무료 AI 이미지 업스케일러 - 4K로 확대 | WeryAI",
            "og_description": "WeryAI의 무료 AI 이미지 향상기로 저해상도 이미지를 2배, 4배, 최대 4K까지 즉시 확대하세요. 흐릿한 사진을 선명하게 하고 노이즈를 제거하며 오래된 가족 사진을 온라인에서 복원합니다. 무손실 품질.",
            "twitter_title": "무료 AI 이미지 업스케일러 - 4K로 확대 | WeryAI",
            "twitter_description": "WeryAI의 무료 AI 이미지 향상기로 저해상도 이미지를 2배, 4배, 최대 4K까지 즉시 확대하세요. 흐릿한 사진을 선명하게 하고 노이즈를 제거하며 오래된 가족 사진을 온라인에서 복원합니다. 무손실 품질.",
            "page": {
                "title1": "무료 AI 이미지 업스케일러 & 향상기",
                "title2": "픽셀 깨짐, 흐림, 또는 오래된 사진을 고해상도 작품으로 바꿔보세요. WeryAI는 고급 AI로 해상도를 최대 400%(4K)까지 높이면서 잃어버린 디테일을 복원하고 노이즈를 수정하며 오래된 가족 초상화의 얼굴을 선명하게 복원합니다.",
                "faq": [
                    {
                        "question": "인쇄용으로 저해상도 이미지를 업스케일할 수 있나요?",
                        "answer": "네! WeryAI는 이미지의 해상도(픽셀 수)를 최대 4K까지 올려 포스터, 캔버스, 마케팅 자료 등 고품질 인쇄에 적합하게 만듭니다."
                    },
                    {
                        "question": "AI 오래된 사진 복원은 어떻게 작동하나요?",
                        "answer": "AI가 오래된 사진의 손상되거나 흐릿한 부분을 분석하고, 딥러닝으로 얼굴 디테일, 질감, 배경을 예측·재구성해 사진을 효과적으로 “복원”합니다."
                    },
                    {
                        "question": "어떤 파일 형식을 지원하나요?",
                        "answer": "JPG, PNG, WEBP 등 일반적인 형식을 지원합니다. 결과물은 고품질 PNG 또는 JPG로 출력됩니다."
                    },
                    {
                        "question": "애니/만화에도 잘 되나요?",
                        "answer": "네. 저희 AI는 애니메이션과 일러스트(waifu2x 스타일) 업스케일에 강해 선을 또렷하게 유지하고 색을 선명하게 살리며 아티팩트를 최소화합니다."
                    },
                    {
                        "question": "WeryAI AI 이미지 업스케일러를 무료로 사용할 수 있나요?",
                        "answer": "네. 신규 사용자는 가입 시 신용카드 없이 무료 크레딧을 받을 수 있습니다. 또한 매일 체크인, 작업 완료, 친구 초대를 통해 무료 크레딧을 더 받을 수 있어 선결제 없이도 계속 사용할 수 있습니다."
                    }
                ]
            },
            "faq": [
                {
                    "question": "인쇄용으로 저해상도 이미지를 업스케일할 수 있나요?",
                    "answer": "네! WeryAI는 해상도를 최대 4K까지 높여 고품질 인쇄에 적합하게 만듭니다."
                },
                {
                    "question": "AI 오래된 사진 복원은 어떻게 작동하나요?",
                    "answer": "AI가 손상된 영역을 분석하고 딥러닝으로 얼굴 디테일과 질감을 재구성해 사진을 복원합니다."
                },
                {
                    "question": "애니에도 잘 되나요?",
                    "answer": "네. 저희 AI는 애니/일러스트 업스케일에 강해 선을 또렷하게 유지하며 아티팩트를 줄입니다."
                }
            ],
            "feature_title1": "무손실 4K 업스케일링",
            "feature_desc1": "인쇄용 퀄리티: 작은 이미지를 인쇄해야 하나요? 품질 손실 없이 4K 또는 8K로 업스케일하세요. 포스터, 전자상거래 제품 사진, 배경화면에 완벽합니다.",
            "feature_title2": "스마트 노이즈 제거 & 선명화",
            "feature_desc2": "야간 사진 복원: 저조도 사진의 디지털 노이즈와 입자를 제거합니다. 흐릿한 가장자리를 즉시 선명하게 만들어 사진을 또렷하고 전문적으로 보이게 합니다.",
            "feature_title3": "오래된 사진 복원",
            "feature_desc3": "추억 되살리기: 오래되었거나 손상되었거나 흑백인 사진이 있나요? AI가 새 픽셀을 생성해 스크래치를 복구하고 얼굴을 선명하게 하며 소중한 추억에 다시 또렷함을 되돌립니다.",
            "howto": {
                "name": "이미지를 4K로 업스케일링하는 방법",
                "step1": {
                    "name": "사진 업로드",
                    "text": "저해상도 또는 흐릿한 이미지를 WeryAI 업스케일러에 업로드하세요."
                },
                "step2": {
                    "name": "배율 선택",
                    "text": "원하는 업스케일링 배율(예: 2x, 4x)을 선택하세요."
                },
                "step3": {
                    "name": "화질 개선",
                    "text": "'만들기'를 클릭하세요. AI가 이미지를 처리하여 해상도와 선명도를 즉시 향상시킵니다."
                }
            }
        }
    },
    "es": {
        "imageUpscaler": {
            "title": "Ampliar Imágenes con IA Gratis - Hasta 4K | WeryAI",
            "description": "Amplía al instante imágenes de baja resolución a 2x, 4x y hasta 4K con el Mejorador de Imágenes IA Gratis de WeryAI. Arregla fotos borrosas, elimina ruido y restaura fotos familiares antiguas en línea. Calidad sin pérdida.",
            "keywords": "escalador de imágenes IA, mejorador de fotos, ampliar imagen a 4k, quitar desenfoque, restauración de fotos antiguas, arreglar foto pixelada, aumentar resolución de imagen",
            "og_title": "Ampliar Imágenes con IA Gratis - Hasta 4K | WeryAI",
            "og_description": "Amplía al instante imágenes de baja resolución a 2x, 4x y hasta 4K con el Mejorador de Imágenes IA Gratis de WeryAI. Arregla fotos borrosas, elimina ruido y restaura fotos familiares antiguas en línea. Calidad sin pérdida.",
            "twitter_title": "Ampliar Imágenes con IA Gratis - Hasta 4K | WeryAI",
            "twitter_description": "Amplía al instante imágenes de baja resolución a 2x, 4x y hasta 4K con el Mejorador de Imágenes IA Gratis de WeryAI. Arregla fotos borrosas, elimina ruido y restaura fotos familiares antiguas en línea. Calidad sin pérdida.",
            "page": {
                "title1": "Escalador y Mejorador de Imágenes IA Gratis",
                "title2": "Convierte fotos pixeladas, borrosas o antiguas en obras maestras en alta definición. WeryAI usa IA avanzada para aumentar la resolución hasta un 400% (4K), recuperando detalles perdidos, corrigiendo ruido y restaurando rostros en retratos familiares antiguos.",
                "faq": [
                    {
                        "question": "¿Puedo ampliar imágenes de baja resolución para imprimir?",
                        "answer": "¡Sí! WeryAI aumenta la resolución (cantidad de píxeles) de tu imagen hasta 4K, haciéndola apta para impresión de alta calidad en pósters, lienzos o materiales de marketing."
                    },
                    {
                        "question": "¿Cómo funciona la restauración de fotos antiguas con IA?",
                        "answer": "La IA analiza las partes dañadas o borrosas de la foto antigua y usa aprendizaje profundo para predecir y reconstruir detalles faciales, texturas y fondos, “curando” la imagen."
                    },
                    {
                        "question": "¿Qué formatos se admiten?",
                        "answer": "Admitimos formatos comunes como JPG, PNG y WEBP. La salida será un PNG o JPG de alta calidad."
                    },
                    {
                        "question": "¿Funciona en anime/cómics?",
                        "answer": "Sí. Nuestra IA destaca al ampliar anime e ilustraciones (estilo waifu2x), manteniendo líneas nítidas y colores vibrantes sin artefactos."
                    },
                    {
                        "question": "¿Puedo usar WeryAI AI Image Upscaler gratis?",
                        "answer": "Sí. Los nuevos usuarios reciben créditos gratis al registrarse sin necesidad de tarjeta de crédito. También puedes conseguir más créditos gratis con el check-in diario, completando tareas e invitando amigos, así que puedes seguir usando la herramienta sin pagar por adelantado."
                    }
                ]
            },
            "faq": [
                {
                    "question": "¿Puedo ampliar imágenes de baja resolución para imprimir?",
                    "answer": "¡Sí! WeryAI aumenta la resolución hasta 4K, haciendo las imágenes aptas para impresión de alta calidad."
                },
                {
                    "question": "¿Cómo funciona la restauración de fotos antiguas con IA?",
                    "answer": "La IA analiza áreas dañadas y reconstruye detalles faciales y texturas con aprendizaje profundo para “curar” la imagen."
                },
                {
                    "question": "¿Funciona en anime?",
                    "answer": "Sí. Nuestra IA destaca al ampliar anime e ilustraciones, manteniendo líneas nítidas sin artefactos."
                }
            ],
            "feature_title1": "Ampliación sin Pérdida hasta 4K",
            "feature_desc1": "Calidad Lista para Imprimir: ¿Necesitas imprimir una imagen pequeña? Amplíala a 4K u 8K sin perder calidad. Perfecto para pósters, fotos de producto para e-commerce y fondos de pantalla.",
            "feature_title2": "Reducción de Ruido y Desenfoque Inteligente",
            "feature_desc2": "Arregla Fotos Nocturnas: Elimina ruido digital y granulado en fotos con poca luz. Enfoca bordes borrosos al instante para que se vean nítidas y profesionales.",
            "feature_title3": "Restauración de Fotos Antiguas",
            "feature_desc3": "Revive Recuerdos: ¿Tienes fotos antiguas, dañadas o en blanco y negro? Nuestra IA crea nuevos píxeles para reparar arañazos, enfocar rostros y devolver claridad a tus recuerdos.",
            "howto": {
                "name": "Cómo mejorar una imagen a 4K",
                "step1": {
                    "name": "Subir foto",
                    "text": "Sube tu imagen borrosa o de baja resolución a WeryAI Upscaler."
                },
                "step2": {
                    "name": "Seleccionar escala",
                    "text": "Elige el factor de mejora deseado (por ejemplo, 2x, 4x)."
                },
                "step3": {
                    "name": "Mejorar",
                    "text": "Haz clic en 'Crear'. La IA procesará la imagen, mejorando instantáneamente la resolución y la claridad."
                }
            }
        }
    },
    "fr": {
        "imageUpscaler": {
            "title": "Agrandir Images par IA - Jusqu'à 4K | WeryAI",
            "description": "Agrandissez instantanément des images basse résolution en 2x, 4x et jusqu'à 4K avec l'Améliorateur d'Image IA Gratuit de WeryAI. Corrigez les photos floues, supprimez le bruit et restaurez en ligne vos anciennes photos de famille. Qualité sans perte.",
            "keywords": "agrandisseur d'image ia, améliorateur de photos, agrandir image en 4k, déflouter image, restauration de vieilles photos, corriger photo pixelisée, augmenter résolution image",
            "og_title": "Agrandir Images par IA - Jusqu'à 4K | WeryAI",
            "og_description": "Agrandissez instantanément des images basse résolution en 2x, 4x et jusqu'à 4K avec l'Améliorateur d'Image IA Gratuit de WeryAI. Corrigez les photos floues, supprimez le bruit et restaurez en ligne vos anciennes photos de famille. Qualité sans perte.",
            "twitter_title": "Agrandir Images par IA - Jusqu'à 4K | WeryAI",
            "twitter_description": "Agrandissez instantanément des images basse résolution en 2x, 4x et jusqu'à 4K avec l'Améliorateur d'Image IA Gratuit de WeryAI. Corrigez les photos floues, supprimez le bruit et restaurez en ligne vos anciennes photos de famille. Qualité sans perte.",
            "page": {
                "title1": "Agrandisseur & Améliorateur d'Image IA Gratuit",
                "title2": "Transformez des photos pixelisées, floues ou anciennes en chefs-d'œuvre haute définition. WeryAI utilise une IA avancée pour augmenter la résolution jusqu'à 400% (4K) tout en récupérant les détails perdus, en corrigeant le bruit et en restaurant les visages sur les portraits de famille anciens.",
                "faq": [
                    {
                        "question": "Puis-je agrandir des images basse résolution pour l'impression ?",
                        "answer": "Oui ! WeryAI augmente la résolution (nombre de pixels) jusqu'à 4K, ce qui convient à une impression de haute qualité sur posters, toiles ou supports marketing."
                    },
                    {
                        "question": "Comment fonctionne la restauration de vieilles photos par IA ?",
                        "answer": "L'IA analyse les zones abîmées ou floues et utilise le deep learning pour prédire et reconstruire les détails du visage, les textures et l'arrière-plan, \"réparant\" ainsi l'image."
                    },
                    {
                        "question": "Quels formats sont pris en charge ?",
                        "answer": "Nous prenons en charge des formats courants comme JPG, PNG et WEBP. La sortie sera un PNG ou JPG de haute qualité."
                    },
                    {
                        "question": "Est-ce que ça marche sur l'anime / les cartoons ?",
                        "answer": "Oui. Notre IA excelle pour agrandir les animes et illustrations (style waifu2x), en gardant des lignes nettes et des couleurs vibrantes sans artefacts."
                    },
                    {
                        "question": "Puis-je utiliser WeryAI AI Image Upscaler gratuitement ?",
                        "answer": "Oui. Les nouveaux utilisateurs reçoivent des crédits gratuits à l'inscription, sans carte bancaire. Vous pouvez aussi obtenir plus de crédits gratuits grâce à la connexion quotidienne, aux tâches terminées et aux invitations d'amis, ce qui vous permet de continuer à utiliser l'outil sans paiement anticipé."
                    }
                ]
            },
            "faq": [
                {
                    "question": "Puis-je agrandir des images basse résolution pour l'impression ?",
                    "answer": "Oui ! WeryAI augmente la résolution jusqu'à 4K, rendant l'image adaptée à une impression de haute qualité."
                },
                {
                    "question": "Comment fonctionne la restauration de vieilles photos par IA ?",
                    "answer": "L'IA analyse les zones endommagées et reconstruit les détails du visage et les textures grâce au deep learning."
                },
                {
                    "question": "Est-ce que ça marche sur l'anime ?",
                    "answer": "Oui. Notre IA excelle pour agrandir les animes et illustrations, en gardant des lignes nettes sans artefacts."
                }
            ],
            "feature_title1": "Agrandissement Sans Perte jusqu'à 4K",
            "feature_desc1": "Qualité prête à imprimer : Besoin d'imprimer une petite image ? Agrandissez-la en 4K ou 8K sans perdre en qualité. Parfait pour posters, photos produit e-commerce et fonds d'écran.",
            "feature_title2": "Débruitage & Défloutage Intelligents",
            "feature_desc2": "Corrigez les photos de nuit : Supprimez le bruit numérique et le grain des photos en faible luminosité. Affûtez les bords flous instantanément pour un rendu net et professionnel.",
            "feature_title3": "Restauration de Vieilles Photos",
            "feature_desc3": "Ravivez vos souvenirs : Photos anciennes, abîmées ou en noir et blanc ? Notre IA crée de nouveaux pixels pour réparer les rayures, affiner les visages et redonner de la clarté à vos souvenirs.",
            "howto": {
                "name": "Comment améliorer une image en 4K",
                "step1": {
                    "name": "Télécharger la photo",
                    "text": "Téléchargez votre image floue ou basse résolution sur WeryAI Upscaler."
                },
                "step2": {
                    "name": "Sélectionner l'échelle",
                    "text": "Choisissez le facteur d'amélioration souhaité (par ex. 2x, 4x)."
                },
                "step3": {
                    "name": "Améliorer",
                    "text": "Cliquez sur « Créer ». L'IA traitera l'image, améliorant instantanément la résolution et la clarté."
                }
            }
        }
    },
    "de": {
        "imageUpscaler": {
            "title": "KI-Bild-Upscaler - Auf 4K Vergrößern | WeryAI",
            "description": "Skalieren Sie niedrig aufgelöste Bilder sofort auf 2x, 4x und bis zu 4K mit WeryAIs kostenlosem KI-Bildverbesserer. Schärfen Sie unscharfe Fotos, entfernen Sie Rauschen und stellen Sie alte Familienfotos online wieder her. Verlustfreie Qualität.",
            "keywords": "KI Bild Upscaler, Foto-Verbesserer, Bild auf 4K hochskalieren, Bild entblurren, alte Fotos wiederherstellen, pixelige Fotos reparieren, Bildauflösung erhöhen",
            "og_title": "KI-Bild-Upscaler - Auf 4K Vergrößern | WeryAI",
            "og_description": "Skalieren Sie niedrig aufgelöste Bilder sofort auf 2x, 4x und bis zu 4K mit WeryAIs kostenlosem KI-Bildverbesserer. Schärfen Sie unscharfe Fotos, entfernen Sie Rauschen und stellen Sie alte Familienfotos online wieder her. Verlustfreie Qualität.",
            "twitter_title": "KI-Bild-Upscaler - Auf 4K Vergrößern | WeryAI",
            "twitter_description": "Skalieren Sie niedrig aufgelöste Bilder sofort auf 2x, 4x und bis zu 4K mit WeryAIs kostenlosem KI-Bildverbesserer. Schärfen Sie unscharfe Fotos, entfernen Sie Rauschen und stellen Sie alte Familienfotos online wieder her. Verlustfreie Qualität.",
            "page": {
                "title1": "Kostenloser KI-Bild-Upscaler & -Verbesserer",
                "title2": "Verwandeln Sie pixelige, unscharfe oder alte Fotos in hochauflösende Meisterwerke. WeryAI nutzt fortschrittliche KI, um die Auflösung um bis zu 400% (4K) zu erhöhen, während verlorene Details wiederhergestellt, Rauschen korrigiert und Gesichter in alten Familienporträts rekonstruiert werden.",
                "faq": [
                    {
                        "question": "Kann ich niedrig aufgelöste Bilder fürs Drucken hochskalieren?",
                        "answer": "Ja! WeryAI erhöht die Auflösung (Pixelanzahl) bis zu 4K und macht Ihr Bild damit geeignet für hochwertige Drucke auf Postern, Leinwand oder Marketingmaterialien."
                    },
                    {
                        "question": "Wie funktioniert die KI-Restaurierung alter Fotos?",
                        "answer": "Die KI analysiert beschädigte oder unscharfe Bereiche und nutzt Deep Learning, um Gesichtdetails, Texturen und Hintergründe vorherzusagen und zu rekonstruieren – sie „heilt“ das Bild effektiv."
                    },
                    {
                        "question": "Welche Formate werden unterstützt?",
                        "answer": "Wir unterstützen gängige Formate wie JPG, PNG und WEBP. Das Ergebnis wird als hochwertiges PNG oder JPG ausgegeben."
                    },
                    {
                        "question": "Funktioniert es bei Anime/Cartoons?",
                        "answer": "Ja. Unsere KI eignet sich hervorragend zum Hochskalieren von Anime und Illustrationen (waifu2x-Stil) und hält Linien scharf sowie Farben lebendig – ohne Artefakte."
                    },
                    {
                        "question": "Kann ich WeryAI AI Image Upscaler kostenlos nutzen?",
                        "answer": "Ja. Neue Nutzer erhalten bei der Registrierung kostenlose Credits, ganz ohne Kreditkarte. Außerdem können Sie durch tägliches Einchecken, das Abschließen von Aufgaben und das Einladen von Freunden weitere kostenlose Credits erhalten, sodass Sie das Tool ohne Vorauszahlung weiter nutzen können."
                    }
                ]
            },
            "faq": [
                {
                    "question": "Kann ich niedrig aufgelöste Bilder fürs Drucken hochskalieren?",
                    "answer": "Ja! WeryAI erhöht die Auflösung bis zu 4K, sodass Bilder für hochwertigen Druck geeignet sind."
                },
                {
                    "question": "Wie funktioniert die KI-Restaurierung alter Fotos?",
                    "answer": "Die KI analysiert beschädigte Bereiche und rekonstruiert Gesichtdetails und Texturen mit Deep Learning, um das Bild zu „heilen“."
                },
                {
                    "question": "Funktioniert es bei Anime?",
                    "answer": "Ja. Unsere KI skaliert Anime und Illustrationen hervorragend hoch und hält Linien scharf – ohne Artefakte."
                }
            ],
            "feature_title1": "Verlustfreies Hochskalieren bis 4K",
            "feature_desc1": "Druckfertige Qualität: Müssen Sie ein kleines Bild drucken? Skalieren Sie es auf 4K oder 8K hoch, ohne Qualität zu verlieren. Perfekt für Poster, E-Commerce-Produktshots und Wallpaper.",
            "feature_title2": "Smartes Entrauschen & Entschärfen",
            "feature_desc2": "Nachtaufnahmen reparieren: Entfernen Sie digitales Rauschen und Körnung aus Low-Light-Fotos. Schärfen Sie unscharfe Kanten sofort, damit Ihre Fotos knackig und professionell aussehen.",
            "feature_title3": "Restaurierung Alter Fotos",
            "feature_desc3": "Erinnerungen wiederbeleben: Alte, beschädigte oder schwarz-weiße Fotos? Unsere KI erzeugt neue Pixel, repariert Kratzer, schärft Gesichter und bringt Klarheit in Ihre wertvollen Erinnerungen zurück.",
            "howto": {
                "name": "Wie man ein Bild auf 4K hochskaliert",
                "step1": {
                    "name": "Foto hochladen",
                    "text": "Laden Sie Ihr niedrigauflösendes oder unscharfes Bild in den WeryAI Upscaler hoch."
                },
                "step2": {
                    "name": "Skalierung wählen",
                    "text": "Wählen Sie Ihren gewünschten Hochskalierungsfaktor (z. B. 2x, 4x)."
                },
                "step3": {
                    "name": "Verbessern",
                    "text": "Klicken Sie auf 'Erstellen'. Die KI verarbeitet das Bild und verbessert sofort Auflösung und Klarheit."
                }
            }
        }
    },
    "ru": {
        "imageUpscaler": {
            "title": "ИИ Увеличение Изображений до 4K | WeryAI",
            "description": "Мгновенно увеличивайте изображения низкого разрешения в 2x, 4x и до 4K с бесплатным ИИ-улучшителем изображений WeryAI. Исправляйте размытые фото, удаляйте шум и восстанавливайте старые семейные фотографии онлайн. Без потери качества.",
            "keywords": "апскейлер изображений ИИ, улучшитель фото, увеличить изображение до 4k, убрать размытость, восстановление старых фото, исправить пикселизацию, увеличить разрешение изображения",
            "og_title": "ИИ Увеличение Изображений до 4K | WeryAI",
            "og_description": "Мгновенно увеличивайте изображения низкого разрешения в 2x, 4x и до 4K с бесплатным ИИ-улучшителем изображений WeryAI. Исправляйте размытые фото, удаляйте шум и восстанавливайте старые семейные фотографии онлайн. Без потери качества.",
            "twitter_title": "ИИ Увеличение Изображений до 4K | WeryAI",
            "twitter_description": "Мгновенно увеличивайте изображения низкого разрешения в 2x, 4x и до 4K с бесплатным ИИ-улучшителем изображений WeryAI. Исправляйте размытые фото, удаляйте шум и восстанавливайте старые семейные фотографии онлайн. Без потери качества.",
            "page": {
                "title1": "Бесплатный ИИ-Апскейлер и Улучшитель Изображений",
                "title2": "Превратите пикселизированные, размытые или старые фотографии в шедевры высокой четкости. WeryAI использует продвинутый ИИ, чтобы увеличить разрешение до 400% (4K), восстанавливая потерянные детали, устраняя шум и восстанавливая лица на старых семейных портретах.",
                "faq": [
                    {
                        "question": "Можно ли увеличить изображения низкого разрешения для печати?",
                        "answer": "Да! WeryAI увеличивает разрешение (количество пикселей) до 4K, делая изображение пригодным для качественной печати на постерах, холсте и маркетинговых материалах."
                    },
                    {
                        "question": "Как работает восстановление старых фото с ИИ?",
                        "answer": "ИИ анализирует поврежденные или размытые участки и с помощью deep learning предсказывает и реконструирует детали лица, текстуры и фон, эффективно “исцеляя” изображение."
                    },
                    {
                        "question": "Какие форматы поддерживаются?",
                        "answer": "Мы поддерживаем распространенные форматы JPG, PNG и WEBP. Результат будет в высококачественном PNG или JPG."
                    },
                    {
                        "question": "Работает ли это с аниме/мультфильмами?",
                        "answer": "Да. Наш ИИ отлично апскейлит аниме и иллюстрации (в стиле waifu2x), сохраняя четкие линии и яркие цвета без артефактов."
                    },
                    {
                        "question": "Можно ли пользоваться WeryAI AI Image Upscaler бесплатно?",
                        "answer": "Да. Новые пользователи получают бесплатные кредиты при регистрации без необходимости вводить банковскую карту. Вы также можете получать больше бесплатных кредитов за ежедневные отметки, выполнение заданий и приглашение друзей, поэтому инструментом можно пользоваться без предоплаты."
                    }
                ]
            },
            "faq": [
                {
                    "question": "Можно ли увеличить изображения низкого разрешения для печати?",
                    "answer": "Да! WeryAI повышает разрешение до 4K, делая изображения пригодными для качественной печати."
                },
                {
                    "question": "Как работает восстановление старых фото с ИИ?",
                    "answer": "ИИ анализирует поврежденные области и реконструирует детали лица и текстуры с помощью deep learning, чтобы “исцелить” изображение."
                },
                {
                    "question": "Работает ли это с аниме?",
                    "answer": "Да. Наш ИИ отлично апскейлит аниме и иллюстрации, сохраняя четкие линии без артефактов."
                }
            ],
            "feature_title1": "Апскейл Без Потери Качества до 4K",
            "feature_desc1": "Качество для печати: Нужно распечатать маленькое изображение? Увеличьте до 4K или 8K без потери качества. Идеально для постеров, фото товаров для e-commerce и обоев.",
            "feature_title2": "Умное Удаление Шума и Размытия",
            "feature_desc2": "Исправляйте ночные снимки: Удаляйте цифровой шум и зернистость на фото при слабом освещении. Мгновенно повышайте резкость размытых краев, чтобы фото выглядели четкими и профессиональными.",
            "feature_title3": "Восстановление Старых Фото",
            "feature_desc3": "Возродите воспоминания: Есть старые, поврежденные или черно-белые фото? Наш ИИ создает новые пиксели, чтобы убрать царапины, повысить резкость лиц и вернуть четкость вашим дорогим воспоминаниям.",
            "howto": {
                "name": "Как улучшить изображение до 4K",
                "step1": {
                    "name": "Загрузить фото",
                    "text": "Загрузите свое изображение с низким разрешением или размытое в WeryAI Upscaler."
                },
                "step2": {
                    "name": "Выбрать масштаб",
                    "text": "Выберите желаемый коэффициент увеличения (например, 2x, 4x)."
                },
                "step3": {
                    "name": "Улучшить",
                    "text": "Нажмите «Создать». ИИ обработает изображение, мгновенно улучшив разрешение и четкость."
                }
            }
        }
    },
    "pt": {
        "imageUpscaler": {
            "title": "Ampliar Imagens com IA - Até 4K | WeryAI",
            "description": "Aumente instantaneamente imagens de baixa resolução para 2x, 4x e até 4K com o Melhorador de Imagem IA Grátis da WeryAI. Corrija fotos borradas, remova ruído e restaure fotos antigas de família online. Qualidade sem perdas.",
            "keywords": "upscaler de imagem IA, melhorador de fotos, aumentar imagem para 4k, remover desfoque, restauração de fotos antigas, corrigir foto pixelada, aumentar resolução da imagem",
            "og_title": "Ampliar Imagens com IA - Até 4K | WeryAI",
            "og_description": "Aumente instantaneamente imagens de baixa resolução para 2x, 4x e até 4K com o Melhorador de Imagem IA Grátis da WeryAI. Corrija fotos borradas, remova ruído e restaure fotos antigas de família online. Qualidade sem perdas.",
            "twitter_title": "Ampliar Imagens com IA - Até 4K | WeryAI",
            "twitter_description": "Aumente instantaneamente imagens de baixa resolução para 2x, 4x e até 4K com o Melhorador de Imagem IA Grátis da WeryAI. Corrija fotos borradas, remova ruído e restaure fotos antigas de família online. Qualidade sem perdas.",
            "page": {
                "title1": "Upscaler e Melhorador de Imagem IA Grátis",
                "title2": "Transforme fotos pixeladas, borradas ou antigas em obras-primas em alta definição. A WeryAI usa IA avançada para aumentar a resolução em até 400% (4K), recuperando detalhes perdidos, corrigindo ruído e restaurando rostos em retratos familiares antigos.",
                "faq": [
                    {
                        "question": "Posso aumentar imagens de baixa resolução para impressão?",
                        "answer": "Sim! A WeryAI aumenta a resolução (quantidade de pixels) da sua imagem até 4K, tornando-a adequada para impressão de alta qualidade em pôsteres, telas ou materiais de marketing."
                    },
                    {
                        "question": "Como funciona a restauração de fotos antigas com IA?",
                        "answer": "A IA analisa as partes danificadas ou borradas da foto antiga e usa deep learning para prever e reconstruir detalhes faciais, texturas e fundos, “curando” a imagem."
                    },
                    {
                        "question": "Quais formatos são suportados?",
                        "answer": "Suportamos formatos comuns como JPG, PNG e WEBP. A saída será um PNG ou JPG de alta qualidade."
                    },
                    {
                        "question": "Funciona em anime/cartoons?",
                        "answer": "Sim. Nossa IA se destaca ao aumentar animes e ilustrações (estilo waifu2x), mantendo linhas nítidas e cores vibrantes sem artefatos."
                    },
                    {
                        "question": "Posso usar o WeryAI AI Image Upscaler de graça?",
                        "answer": "Sim. Novos usuários ganham créditos grátis ao se cadastrar, sem necessidade de cartão de crédito. Você também pode ganhar mais créditos grátis com o check-in diário, concluindo tarefas e convidando amigos, para continuar usando a ferramenta sem pagamento antecipado."
                    }
                ]
            },
            "faq": [
                {
                    "question": "Posso aumentar imagens de baixa resolução para impressão?",
                    "answer": "Sim! A WeryAI aumenta a resolução até 4K, tornando as imagens adequadas para impressão de alta qualidade."
                },
                {
                    "question": "Como funciona a restauração de fotos antigas com IA?",
                    "answer": "A IA analisa áreas danificadas e reconstrói detalhes faciais e texturas com deep learning para “curar” a imagem."
                },
                {
                    "question": "Funciona em anime?",
                    "answer": "Sim. Nossa IA se destaca ao aumentar animes e ilustrações, mantendo linhas nítidas sem artefatos."
                }
            ],
            "feature_title1": "Upscaling Sem Perdas até 4K",
            "feature_desc1": "Qualidade Pronta para Impressão: Precisa imprimir uma imagem pequena? Aumente para 4K ou 8K sem perder qualidade. Perfeito para pôsteres, fotos de produto para e-commerce e papéis de parede.",
            "feature_title2": "Redução de Ruído e Desfoque Inteligente",
            "feature_desc2": "Corrija Fotos Noturnas: Remova ruído digital e granulação de fotos com pouca luz. Deixe bordas borradas mais nítidas instantaneamente para que suas fotos pareçam claras e profissionais.",
            "feature_title3": "Restauração de Fotos Antigas",
            "feature_desc3": "Reviva Memórias: Tem fotos antigas, danificadas ou em preto e branco? Nossa IA cria novos pixels para reparar riscos, deixar rostos mais nítidos e devolver clareza às suas lembranças.",
            "howto": {
                "name": "Como melhorar a imagem para 4K",
                "step1": {
                    "name": "Enviar foto",
                    "text": "Envie sua imagem de baixa resolução ou desfocada para o WeryAI Upscaler."
                },
                "step2": {
                    "name": "Selecionar escala",
                    "text": "Escolha o fator de melhoria desejado (por exemplo, 2x, 4x)."
                },
                "step3": {
                    "name": "Melhorar",
                    "text": "Clique em 'Criar'. A IA processará a imagem, melhorando instantaneamente a resolução e a clareza."
                }
            }
        }
    },
    "it": {
        "imageUpscaler": {
            "title": "Ingrandire Immagini con IA - Fino a 4K | WeryAI",
            "description": "Ingrandisci istantaneamente immagini a bassa risoluzione a 2x, 4x e fino a 4K con il Miglioratore Immagini IA Gratis di WeryAI. Sistema foto sfocate, rimuovi il rumore e restaura online vecchie foto di famiglia. Qualità senza perdita.",
            "keywords": "upscaler immagini IA, miglioratore foto, ingrandire immagine a 4k, rimuovere sfocatura, restauro vecchie foto, correggere foto pixelata, aumentare risoluzione immagine",
            "og_title": "Ingrandire Immagini con IA - Fino a 4K | WeryAI",
            "og_description": "Ingrandisci istantaneamente immagini a bassa risoluzione a 2x, 4x e fino a 4K con il Miglioratore Immagini IA Gratis di WeryAI. Sistema foto sfocate, rimuovi il rumore e restaura online vecchie foto di famiglia. Qualità senza perdita.",
            "twitter_title": "Ingrandire Immagini con IA - Fino a 4K | WeryAI",
            "twitter_description": "Ingrandisci istantaneamente immagini a bassa risoluzione a 2x, 4x e fino a 4K con il Miglioratore Immagini IA Gratis di WeryAI. Sistema foto sfocate, rimuovi il rumore e restaura online vecchie foto di famiglia. Qualità senza perdita.",
            "page": {
                "title1": "Upscaler e Miglioratore Immagini IA Gratis",
                "title2": "Trasforma foto pixelate, sfocate o vecchie in capolavori ad alta definizione. WeryAI usa IA avanzata per aumentare la risoluzione fino al 400% (4K), recuperando dettagli persi, correggendo il rumore e restaurando i volti nei vecchi ritratti di famiglia.",
                "faq": [
                    {
                        "question": "Posso ingrandire immagini a bassa risoluzione per la stampa?",
                        "answer": "Sì! WeryAI aumenta la risoluzione (numero di pixel) fino a 4K, rendendola adatta a stampe di alta qualità su poster, tela o materiali di marketing."
                    },
                    {
                        "question": "Come funziona il restauro di vecchie foto con IA?",
                        "answer": "L'IA analizza le parti danneggiate o sfocate della foto e usa il deep learning per prevedere e ricostruire dettagli del viso, texture e sfondi, “guarendo” l'immagine."
                    },
                    {
                        "question": "Quali formati sono supportati?",
                        "answer": "Supportiamo formati comuni come JPG, PNG e WEBP. L'output sarà un PNG o JPG di alta qualità."
                    },
                    {
                        "question": "Funziona con anime/cartoni?",
                        "answer": "Sì. La nostra IA eccelle nell'upscaling di anime e illustrazioni (stile waifu2x), mantenendo linee nitide e colori vivaci senza artefatti."
                    },
                    {
                        "question": "Posso usare WeryAI AI Image Upscaler gratis?",
                        "answer": "Sì. I nuovi utenti ricevono crediti gratuiti alla registrazione, senza bisogno di carta di credito. Puoi anche ottenere più crediti gratuiti con il check-in giornaliero, completando attività e invitando amici, così puoi continuare a usare lo strumento senza pagamenti anticipati."
                    }
                ]
            },
            "faq": [
                {
                    "question": "Posso ingrandire immagini a bassa risoluzione per la stampa?",
                    "answer": "Sì! WeryAI aumenta la risoluzione fino a 4K, rendendo le immagini adatte alla stampa di alta qualità."
                },
                {
                    "question": "Come funziona il restauro di vecchie foto con IA?",
                    "answer": "L'IA analizza le aree danneggiate e ricostruisce dettagli del viso e texture con il deep learning per “guarire” l'immagine."
                },
                {
                    "question": "Funziona con anime?",
                    "answer": "Sì. La nostra IA eccelle nell'upscaling di anime e illustrazioni, mantenendo linee nitide senza artefatti."
                }
            ],
            "feature_title1": "Upscaling Senza Perdita fino a 4K",
            "feature_desc1": "Qualità Pronta per la Stampa: Devi stampare un'immagine piccola? Ingrandiscila a 4K o 8K senza perdere qualità. Perfetto per poster, foto prodotto e-commerce e wallpaper.",
            "feature_title2": "Riduzione Rumore & Deblur Intelligenti",
            "feature_desc2": "Sistema le Foto Notturne: Rimuovi rumore digitale e grana dalle foto in scarsa luce. Rendi nitidi i bordi sfocati all'istante per foto più chiare e professionali.",
            "feature_title3": "Restauro di Vecchie Foto",
            "feature_desc3": "Ravviva i Ricordi: Hai foto vecchie, danneggiate o in bianco e nero? La nostra IA crea nuovi pixel per riparare graffi, rendere i volti più nitidi e riportare chiarezza ai tuoi ricordi.",
            "howto": {
                "name": "Come migliorare l'immagine in 4K",
                "step1": {
                    "name": "Carica foto",
                    "text": "Carica la tua immagine a bassa risoluzione o sfocata su WeryAI Upscaler."
                },
                "step2": {
                    "name": "Seleziona scala",
                    "text": "Scegli il fattore di miglioramento desiderato (es. 2x, 4x)."
                },
                "step3": {
                    "name": "Migliora",
                    "text": "Fai clic su 'Crea'. L'IA elaborerà l'immagine, migliorando istantaneamente risoluzione e chiarezza."
                }
            }
        }
    },
    "ar": {
        "imageUpscaler": {
            "title": "تكبير الصور بالذكاء الاصطناعي - حتى 4K | WeryAI",
            "description": "كبّر الصور منخفضة الدقة فورًا إلى 2x و4x وحتى 4K باستخدام محسّن الصور المجاني من WeryAI. أصلح الصور الضبابية، أزل الضوضاء، واستعد صور العائلة القديمة عبر الإنترنت بجودة بدون فقدان.",
            "keywords": "مكبر الصور بالذكاء الاصطناعي, محسّن الصور, تكبير الصورة إلى 4k, إزالة الضبابية, استعادة الصور القديمة, إصلاح الصور المكسّرة, زيادة دقة الصورة",
            "og_title": "تكبير الصور بالذكاء الاصطناعي - حتى 4K | WeryAI",
            "og_description": "كبّر الصور منخفضة الدقة فورًا إلى 2x و4x وحتى 4K باستخدام محسّن الصور المجاني من WeryAI. أصلح الصور الضبابية، أزل الضوضاء، واستعد صور العائلة القديمة عبر الإنترنت بجودة بدون فقدان.",
            "twitter_title": "تكبير الصور بالذكاء الاصطناعي - حتى 4K | WeryAI",
            "twitter_description": "كبّر الصور منخفضة الدقة فورًا إلى 2x و4x وحتى 4K باستخدام محسّن الصور المجاني من WeryAI. أصلح الصور الضبابية، أزل الضوضاء، واستعد صور العائلة القديمة عبر الإنترنت بجودة بدون فقدان.",
            "page": {
                "title1": "مكبّر ومحسّن الصور بالذكاء الاصطناعي مجانًا",
                "title2": "حوّل الصور المكسّرة أو الضبابية أو القديمة إلى روائع عالية الدقة. يستخدم WeryAI ذكاءً اصطناعيًا متقدمًا لزيادة الدقة حتى 400% (4K) مع استعادة التفاصيل المفقودة، وإصلاح الضوضاء، واستعادة الوجوه في صور العائلة القديمة.",
                "faq": [
                    {
                        "question": "هل يمكنني تكبير الصور منخفضة الدقة للطباعة؟",
                        "answer": "نعم! يزيد WeryAI دقة الصورة (عدد البكسلات) حتى 4K، مما يجعلها مناسبة للطباعة عالية الجودة على الملصقات أو اللوحات القماشية أو مواد التسويق."
                    },
                    {
                        "question": "كيف تعمل استعادة الصور القديمة بالذكاء الاصطناعي؟",
                        "answer": "يحلل الذكاء الاصطناعي الأجزاء التالفة أو الضبابية من الصورة القديمة ويستخدم التعلم العميق للتنبؤ وإعادة بناء تفاصيل الوجه والملمس والخلفيات، مما “يعالج” الصورة بشكل فعال."
                    },
                    {
                        "question": "ما الصيغ المدعومة؟",
                        "answer": "ندعم الصيغ الشائعة مثل JPG وPNG وWEBP. سيكون الإخراج بصيغة PNG أو JPG عالية الجودة."
                    },
                    {
                        "question": "هل يعمل مع الأنمي/الرسوم؟",
                        "answer": "نعم. يتفوّق ذكاؤنا الاصطناعي في تكبير الأنمي والرسومات (نمط waifu2x)، مع الحفاظ على خطوط حادة وألوان نابضة دون تشوهات."
                    },
                    {
                        "question": "هل يمكنني استخدام WeryAI AI Image Upscaler مجانًا؟",
                        "answer": "نعم. يحصل المستخدمون الجدد على أرصدة مجانية عند التسجيل من دون الحاجة إلى بطاقة ائتمان. ويمكنك أيضًا الحصول على المزيد من الأرصدة المجانية عبر تسجيل الدخول اليومي وإكمال المهام ودعوة الأصدقاء، لذلك يمكنك مواصلة استخدام الأداة دون دفع مسبق."
                    }
                ]
            },
            "faq": [
                {
                    "question": "هل يمكنني تكبير الصور منخفضة الدقة للطباعة؟",
                    "answer": "نعم! يزيد WeryAI الدقة حتى 4K، مما يجعل الصور مناسبة للطباعة عالية الجودة."
                },
                {
                    "question": "كيف تعمل استعادة الصور القديمة بالذكاء الاصطناعي؟",
                    "answer": "يحلل الذكاء الاصطناعي المناطق التالفة ويعيد بناء تفاصيل الوجه والملمس باستخدام التعلم العميق “لعلاج” الصورة."
                },
                {
                    "question": "هل يعمل مع الأنمي؟",
                    "answer": "نعم. يتفوّق ذكاؤنا الاصطناعي في تكبير الأنمي والرسومات مع الحفاظ على خطوط حادة دون تشوهات."
                }
            ],
            "feature_title1": "تكبير بدون فقدان حتى 4K",
            "feature_desc1": "جودة جاهزة للطباعة: هل تحتاج لطباعة صورة صغيرة؟ كبّرها إلى 4K أو 8K بدون فقدان الجودة. مثالي للملصقات وصور منتجات التجارة الإلكترونية وخلفيات الشاشة.",
            "feature_title2": "إزالة الضوضاء وإزالة الضبابية بذكاء",
            "feature_desc2": "أصلح صور الليل: أزل الضوضاء الرقمية والحبيبات من الصور منخفضة الإضاءة. حَدّد الحواف الضبابية فورًا لتبدو صورك واضحة واحترافية.",
            "feature_title3": "استعادة الصور القديمة",
            "feature_desc3": "أعد إحياء الذكريات: هل لديك صور قديمة أو تالفة أو بالأبيض والأسود؟ ينشئ ذكاؤنا الاصطناعي بكسلات جديدة لإصلاح الخدوش وتوضيح الوجوه وإعادة الوضوح لذكرياتك الثمينة.",
            "howto": {
                "name": "كيفية ترقية الصورة إلى 4K",
                "step1": {
                    "name": "تحميل الصورة",
                    "text": "قم بتحميل صورتك منخفضة الدقة أو الباهتة إلى WeryAI Upscaler."
                },
                "step2": {
                    "name": "تحديد المقياس",
                    "text": "اختر عامل الترقية المطلوب (مثل 2x، 4x)."
                },
                "step3": {
                    "name": "تحسين",
                    "text": "انقر على 'إنشاء'. سيقوم الذكاء الاصطناعي بمعالجة الصورة، مما يؤدي إلى تحسين الدقة والوضوح على الفور."
                }
            }
        }
    },
    "tw": {
        "imageUpscaler": {
            "title": "免費 AI 圖片放大器 - 放大至 4K | WeryAI",
            "description": "把模糊、低解析度與老照片一鍵升級到更清晰的畫質。WeryAI 支援放大、降噪、去模糊與老照片修復，適合電商、設計與家庭照片保存。",
            "keywords": "AI 圖片放大器, 照片增強器, 升級圖片至 4K, 消除圖片模糊, 舊照片修復, 修復像素化照片, 提高圖片解析度",
            "og_title": "免費 AI 圖片放大器 - 放大至 4K | WeryAI",
            "og_description": "把模糊、低解析度與老照片一鍵升級到更清晰的畫質。WeryAI 支援放大、降噪、去模糊與老照片修復，適合電商、設計與家庭照片保存。",
            "twitter_title": "免費 AI 圖片放大器 - 放大至 4K | WeryAI",
            "twitter_description": "把模糊、低解析度與老照片一鍵升級到更清晰的畫質。WeryAI 支援放大、降噪、去模糊與老照片修復，適合電商、設計與家庭照片保存。",
            "page": {
                "title1": "免費 AI 圖像增強器與放大器",
                "title2": "將像素化、模糊或老舊照片轉換為高清傑作。WeryAI 使用先進 AI 技術將圖像解析度提升高達 400%（4K），同時恢復遺失的細節、修復噪點並還原老舊家庭肖像中的人臉。",
                "faq": [
                    {
                        "question": "我可以放大低解析度圖像用於列印嗎？",
                        "answer": "可以！WeryAI 可以將圖像的解析度（像素數）提升至 4K，使其適合在海報、畫布或行銷素材上進行高品質列印。"
                    },
                    {
                        "question": "AI 老照片修復是如何運作的？",
                        "answer": "AI 會分析老照片中受損或模糊的部分，使用深度學習來預測和重建面部細節、紋理和背景，有效地「修復」圖像。"
                    },
                    {
                        "question": "支援哪些格式？",
                        "answer": "我們支援常見格式，如 JPG、PNG 和 WEBP。輸出將是高品質的 PNG 或 JPG。"
                    },
                    {
                        "question": "它適用於動漫／卡通嗎？",
                        "answer": "是的。我們的 AI 擅長放大動漫和插畫（waifu2x 風格），保持線條清晰、色彩鮮豔，無偽影。"
                    },
                    {
                        "question": "我可以免費使用 WeryAI AI 圖片放大器嗎？",
                        "answer": "可以。新用戶註冊即可獲得免費點數，無需綁定信用卡。您還可以透過每日簽到、完成任務和邀請好友獲得更多免費點數，因此可以持續使用而無需預付費用。"
                    }
                ]
            },
            "faq": [
                {
                    "question": "我可以放大低解析度圖像用於列印嗎？",
                    "answer": "可以！WeryAI 可以將解析度提升至 4K，使圖像適合高品質列印。"
                },
                {
                    "question": "AI 老照片修復是如何運作的？",
                    "answer": "AI 會分析受損區域，使用深度學習重建面部細節和紋理，以修復圖像。"
                },
                {
                    "question": "它適用於動漫嗎？",
                    "answer": "是的。我們的 AI 擅長放大動漫和插畫，保持線條清晰，無偽影。"
                }
            ],
            "feature_title1": "無損放大至 4K",
            "feature_desc1": "列印就緒品質：需要列印小圖像嗎？將其放大至 4K 或 8K 而不損失品質。非常適合海報、電商產品照片和桌布。",
            "feature_title2": "智慧降噪和去模糊",
            "feature_desc2": "修復夜景照片：去除低光照片中的數位噪點和顆粒。即時銳化模糊邊緣，讓您的照片看起來清晰專業。",
            "feature_title3": "老照片修復",
            "feature_desc3": "重拾回憶：有老舊、受損或黑白照片嗎？我們的 AI 創建新像素來修復刮痕、銳化人臉，並為您珍貴的回憶帶來清晰度。",
            "howto": {
                "name": "如何將圖片無損放大至 4K",
                "step1": {
                    "name": "上傳照片",
                    "text": "將您的低解析度或模糊圖片上傳到 WeryAI 放大器。"
                },
                "step2": {
                    "name": "選擇比例",
                    "text": "選擇您想要的放大倍數（例如 2x、4x）。"
                },
                "step3": {
                    "name": "增強",
                    "text": "點擊「建立」。AI 將處理圖片，瞬間提升解析度和清晰度。"
                }
            }
        }
    },
    "pl": {
        "imageUpscaler": {
            "title": "Darmowy AI Upscaler Obrazów - Powiększ do 4K | WeryAI",
            "description": "Powiększ obrazy o niskiej rozdzielczości do 2x, 4x lub 4K dzięki AI. Napraw rozmyte zdjęcia, usuń szum i odrestauruj stare fotografie. Darmowe kredyty na start, bez karty kredytowej.",
            "keywords": "AI upscaler obrazów, powiększanie zdjęć, powiększ obraz do 4K, napraw rozmyte zdjęcie, odrestauruj stare zdjęcia, poprawa rozdzielczości, WeryAI",
            "og_title": "Darmowy AI Upscaler Obrazów - Powiększ do 4K | WeryAI",
            "og_description": "Powiększ obrazy o niskiej rozdzielczości do 2x, 4x lub 4K dzięki AI. Napraw rozmyte zdjęcia, usuń szum i odrestauruj stare fotografie. Darmowe kredyty na start, bez karty kredytowej.",
            "twitter_title": "Darmowy AI Upscaler Obrazów - Powiększ do 4K | WeryAI",
            "twitter_description": "Powiększ obrazy o niskiej rozdzielczości do 2x, 4x lub 4K dzięki AI. Napraw rozmyte zdjęcia, usuń szum i odrestauruj stare fotografie. Darmowe kredyty na start, bez karty kredytowej.",
            "page": {
                "title1": "Darmowy AI Upscaler i Ulepszacz Obrazów",
                "title2": "Zamień pikselowane, rozmyte lub stare zdjęcia w arcydzieła w wysokiej rozdzielczości. WeryAI wykorzystuje zaawansowaną AI do powiększania rozdzielczości nawet o 400% (4K), odzyskując utracone detale, naprawiając szumy i odtwarzając twarze na starych portretach rodzinnych.",
                "faq": [
                    {
                        "question": "Czy mogę powiększyć obrazy o niskiej rozdzielczości do druku?",
                        "answer": "Tak! WeryAI zwiększa rozdzielczość (liczbę pikseli) do 4K, dzięki czemu obraz nadaje się do wysokiej jakości druku na plakatach, płótnach lub materiałach marketingowych."
                    },
                    {
                        "question": "Jak działa AI restauracja starych zdjęć?",
                        "answer": "AI analizuje uszkodzone lub rozmyte fragmenty starego zdjęcia i wykorzystuje deep learning do przewidywania i odtwarzania detali twarzy, tekstur oraz tła, skutecznie \"naprawiając\" obraz."
                    },
                    {
                        "question": "Jakie formaty są obsługiwane?",
                        "answer": "Obsługujemy popularne formaty: JPG, PNG i WEBP. Wynik zostanie zapisany w wysokiej jakości PNG lub JPG."
                    },
                    {
                        "question": "Czy działa z anime/ilustracjami?",
                        "answer": "Tak. Nasza AI doskonale radzi sobie z powiększaniem anime i ilustracji (styl waifu2x), zachowując ostre linie i żywe kolory bez artefaktów."
                    },
                    {
                        "question": "Czy mogę korzystać z WeryAI AI Image Upscaler za darmo?",
                        "answer": "Tak. Nowi użytkownicy otrzymują darmowe kredyty przy rejestracji bez podawania karty kredytowej. Można też zdobyć więcej darmowych kredytów poprzez codzienne logowanie, wykonywanie zadań i zapraszanie znajomych, co pozwala korzystać z narzędzia bez opłat wstępnych."
                    }
                ]
            },
            "faq": [
                {
                    "question": "Czy mogę powiększyć obrazy o niskiej rozdzielczości do druku?",
                    "answer": "Tak! WeryAI zwiększa rozdzielczość do 4K, dzięki czemu obraz nadaje się do druku wysokiej jakości."
                },
                {
                    "question": "Jak działa AI restauracja starych zdjęć?",
                    "answer": "AI analizuje uszkodzone fragmenty i odtwarza detale twarzy oraz tekstury za pomocą deep learning."
                },
                {
                    "question": "Czy działa z anime?",
                    "answer": "Tak. Nasza AI doskonale powiększa anime i ilustracje, zachowując ostre linie bez artefaktów."
                }
            ],
            "feature_title1": "Bezstratne Powiększanie do 4K",
            "feature_desc1": "Jakość gotowa do druku: Musisz wydrukować mały obraz? Powiększ go do 4K lub 8K bez utraty jakości. Idealne do plakatów, zdjęć produktów e-commerce i tapet.",
            "feature_title2": "Inteligentne Usuwanie Szumu i Rozmycia",
            "feature_desc2": "Napraw nocne zdjęcia: Usuń cyfrowy szum i ziarnistość ze zdjęć przy słabym oświetleniu. Natychmiast wyostrz rozmyte krawędzie, aby zdjęcia wyglądały ostro i profesjonalnie.",
            "feature_title3": "Restauracja Starych Zdjęć",
            "feature_desc3": "Ożyw wspomnienia: Masz stare, uszkodzone lub czarno-białe zdjęcia? Nasza AI tworzy nowe piksele, naprawia zadrapania, wyostrza twarze i przywraca ostrość Twoim cennym wspomnieniom.",
            "howto": {
                "name": "Jak powiększyć obraz do 4K",
                "step1": {
                    "name": "Prześlij zdjęcie",
                    "text": "Prześlij obraz o niskiej rozdzielczości lub rozmyty do WeryAI Upscaler."
                },
                "step2": {
                    "name": "Wybierz skalę",
                    "text": "Wybierz żądany współczynnik powiększenia (np. 2x, 4x)."
                },
                "step3": {
                    "name": "Ulepsz",
                    "text": "Kliknij \"Utwórz\". AI przetworzy obraz, natychmiast poprawiając rozdzielczość i ostrość."
                }
            }
        }
    },
    "th": {
        "imageUpscaler": {
            "title": "ขยายรูปภาพ AI ฟรี - ถึง 4K | WeryAI",
            "description": "ขยายภาพความละเอียดต่ำเป็น 2x, 4x หรือ 4K ด้วย AI แก้ไขภาพเบลอ ลดนอยส์ และกู้คืนภาพเก่า เครดิตฟรีเมื่อสมัคร ไม่ต้องใช้บัตรเครดิต",
            "keywords": "AI ขยายภาพ, ปรับปรุงคุณภาพภาพ, ขยายภาพเป็น 4K, แก้ภาพเบลอ, กู้คืนภาพเก่า, เพิ่มความละเอียดภาพ, WeryAI",
            "og_title": "ขยายรูปภาพ AI ฟรี - ถึง 4K | WeryAI",
            "og_description": "ขยายภาพความละเอียดต่ำเป็น 2x, 4x หรือ 4K ด้วย AI แก้ไขภาพเบลอ ลดนอยส์ และกู้คืนภาพเก่า เครดิตฟรีเมื่อสมัคร ไม่ต้องใช้บัตรเครดิต",
            "twitter_title": "ขยายรูปภาพ AI ฟรี - ถึง 4K | WeryAI",
            "twitter_description": "ขยายภาพความละเอียดต่ำเป็น 2x, 4x หรือ 4K ด้วย AI แก้ไขภาพเบลอ ลดนอยส์ และกู้คืนภาพเก่า เครดิตฟรีเมื่อสมัคร ไม่ต้องใช้บัตรเครดิต",
            "page": {
                "title1": "เครื่องมือขยายและปรับปรุงคุณภาพภาพ AI ฟรี",
                "title2": "เปลี่ยนภาพแตก เบลอ หรือภาพเก่าให้เป็นผลงานคุณภาพสูง WeryAI ใช้ AI ขั้นสูงเพิ่มความละเอียดสูงสุด 400% (4K) พร้อมกู้คืนรายละเอียดที่สูญหาย แก้นอยส์ และฟื้นฟูใบหน้าในภาพถ่ายครอบครัวเก่า",
                "faq": [
                    {
                        "question": "ฉันสามารถขยายภาพความละเอียดต่ำเพื่อพิมพ์ได้ไหม?",
                        "answer": "ได้! WeryAI เพิ่มความละเอียด (จำนวนพิกเซล) สูงสุดถึง 4K ทำให้เหมาะสำหรับการพิมพ์คุณภาพสูงบนโปสเตอร์ ผ้าใบ หรือสื่อการตลาด"
                    },
                    {
                        "question": "AI กู้คืนภาพเก่าทำงานอย่างไร?",
                        "answer": "AI จะวิเคราะห์ส่วนที่เสียหายหรือเบลอของภาพเก่า และใช้ Deep Learning เพื่อทำนายและสร้างรายละเอียดใบหน้า พื้นผิว และฉากหลังขึ้นมาใหม่ เสมือน \"รักษา\" ภาพ"
                    },
                    {
                        "question": "รองรับไฟล์รูปแบบใดบ้าง?",
                        "answer": "รองรับรูปแบบทั่วไป เช่น JPG, PNG และ WEBP ผลลัพธ์จะเป็นไฟล์ PNG หรือ JPG คุณภาพสูง"
                    },
                    {
                        "question": "ใช้กับภาพอนิเมะ/การ์ตูนได้ไหม?",
                        "answer": "ได้ AI ของเราเชี่ยวชาญในการขยายอนิเมะและภาพวาด (สไตล์ waifu2x) รักษาเส้นคมชัดและสีสดใสโดยไม่มีอาร์ติแฟกต์"
                    },
                    {
                        "question": "ฉันสามารถใช้ WeryAI AI Image Upscaler ฟรีได้ไหม?",
                        "answer": "ได้ ผู้ใช้ใหม่จะได้รับเครดิตฟรีเมื่อสมัครสมาชิก ไม่ต้องใช้บัตรเครดิต คุณยังสามารถรับเครดิตฟรีเพิ่มเติมผ่านการเช็คอินรายวัน ทำภารกิจ และเชิญเพื่อน จึงใช้งานต่อเนื่องได้โดยไม่ต้องจ่ายล่วงหน้า"
                    }
                ]
            },
            "faq": [
                {
                    "question": "ฉันสามารถขยายภาพความละเอียดต่ำเพื่อพิมพ์ได้ไหม?",
                    "answer": "ได้! WeryAI เพิ่มความละเอียดสูงสุดถึง 4K ทำให้ภาพเหมาะสำหรับการพิมพ์คุณภาพสูง"
                },
                {
                    "question": "AI กู้คืนภาพเก่าทำงานอย่างไร?",
                    "answer": "AI วิเคราะห์ส่วนที่เสียหายและสร้างรายละเอียดใบหน้าและพื้นผิวใหม่ด้วย Deep Learning"
                },
                {
                    "question": "ใช้กับอนิเมะได้ไหม?",
                    "answer": "ได้ AI ของเราเชี่ยวชาญในการขยายอนิเมะและภาพวาด รักษาเส้นคมชัดโดยไม่มีอาร์ติแฟกต์"
                }
            ],
            "feature_title1": "ขยายแบบไม่สูญเสียคุณภาพถึง 4K",
            "feature_desc1": "คุณภาพพร้อมพิมพ์: ต้องพิมพ์ภาพขนาดเล็ก? ขยายเป็น 4K หรือ 8K โดยไม่สูญเสียคุณภาพ เหมาะสำหรับโปสเตอร์ ภาพสินค้า และวอลเปเปอร์",
            "feature_title2": "ลดนอยส์และเบลออัจฉริยะ",
            "feature_desc2": "แก้ไขภาพกลางคืน: ลบนอยส์ดิจิทัลและเกรนจากภาพแสงน้อย ทำให้ขอบเบลอคมชัดทันทีเพื่อภาพที่ดูคมและเป็นมืออาชีพ",
            "feature_title3": "กู้คืนภาพเก่า",
            "feature_desc3": "ฟื้นฟูความทรงจำ: มีภาพเก่า เสียหาย หรือขาวดำ? AI ของเราสร้างพิกเซลใหม่เพื่อซ่อมรอยขีดข่วน ทำให้ใบหน้าคมชัด และคืนความชัดเจนให้ความทรงจำอันล้ำค่า",
            "howto": {
                "name": "วิธีขยายขนาดรูปภาพเป็น 4K",
                "step1": {
                    "name": "อัปโหลดรูปภาพ",
                    "text": "อัปโหลดรูปภาพที่มีความละเอียดต่ำหรือเบลอไปที่ WeryAI Upscaler"
                },
                "step2": {
                    "name": "เลือกขนาด",
                    "text": "เลือกปัจจัยการขยายขนาดที่คุณต้องการ (เช่น 2x, 4x)"
                },
                "step3": {
                    "name": "ปรับปรุง",
                    "text": "คลิก 'สร้าง' AI จะประมวลผลรูปภาพ ปรับปรุงความละเอียดและความคมชัดในทันที"
                }
            }
        }
    },
    "da": {
        "imageUpscaler": {
            "title": "Gratis AI Billedforstørrer - Op til 4K | WeryAI",
            "description": "Opskalér billeder i lav opløsning til 2x, 4x eller 4K med AI. Ret slørede fotos, fjern støj og restaurer gamle fotos. Gratis credits ved tilmelding, intet kreditkort påkrævet.",
            "keywords": "AI billed-upscaler, fotoforstørrer, opskalér billede til 4K, fjern sløring, restaurer gamle fotos, ret pixeleret foto, øg billedopløsning, WeryAI",
            "og_title": "Gratis AI Billedforstørrer - Op til 4K | WeryAI",
            "og_description": "Opskalér billeder i lav opløsning til 2x, 4x eller 4K med AI. Ret slørede fotos, fjern støj og restaurer gamle fotos. Gratis credits ved tilmelding, intet kreditkort påkrævet.",
            "twitter_title": "Gratis AI Billedforstørrer - Op til 4K | WeryAI",
            "twitter_description": "Opskalér billeder i lav opløsning til 2x, 4x eller 4K med AI. Ret slørede fotos, fjern støj og restaurer gamle fotos. Gratis credits ved tilmelding, intet kreditkort påkrævet.",
            "page": {
                "title1": "Gratis AI Billed-Upscaler & Forbedrer",
                "title2": "Forvandl pixelerede, slørede eller gamle fotos til mesterværker i høj opløsning. WeryAI bruger avanceret AI til at øge opløsningen med op til 400% (4K) og genskaber tabte detaljer, retter støj og restaurerer ansigter i gamle familieportrætter.",
                "faq": [
                    {
                        "question": "Kan jeg opskalere billeder i lav opløsning til print?",
                        "answer": "Ja! WeryAI øger opløsningen (pixelantal) op til 4K, så billedet er egnet til print af høj kvalitet på plakater, lærred eller marketingmaterialer."
                    },
                    {
                        "question": "Hvordan fungerer AI-restaurering af gamle fotos?",
                        "answer": "AI analyserer beskadigede eller slørede dele af det gamle foto og bruger deep learning til at forudsige og genskabe ansigtsdetaljer, teksturer og baggrunde og \"reparerer\" effektivt billedet."
                    },
                    {
                        "question": "Hvilke formater understøttes?",
                        "answer": "Vi understøtter gængse formater som JPG, PNG og WEBP. Output vil være en PNG eller JPG i høj kvalitet."
                    },
                    {
                        "question": "Virker det på anime/tegneserier?",
                        "answer": "Ja. Vores AI er fremragende til at opskalere anime og illustrationer (waifu2x-stil) og holder linjer skarpe og farver levende uden artefakter."
                    },
                    {
                        "question": "Kan jeg bruge WeryAI AI Image Upscaler gratis?",
                        "answer": "Ja. Nye brugere får gratis credits ved tilmelding uden kreditkort. Du kan også optjene flere gratis credits via dagligt check-in, fuldførte opgaver og ved at invitere venner, så du kan fortsætte med at bruge værktøjet uden forudbetaling."
                    }
                ]
            },
            "faq": [
                {
                    "question": "Kan jeg opskalere billeder i lav opløsning til print?",
                    "answer": "Ja! WeryAI øger opløsningen op til 4K, så billeder er egnede til print af høj kvalitet."
                },
                {
                    "question": "Hvordan fungerer AI-restaurering af gamle fotos?",
                    "answer": "AI analyserer beskadigede områder og genskaber ansigtsdetaljer og teksturer med deep learning."
                },
                {
                    "question": "Virker det på anime?",
                    "answer": "Ja. Vores AI er fremragende til at opskalere anime og illustrationer og holder linjer skarpe uden artefakter."
                }
            ],
            "feature_title1": "Tabsfri Opskalering til 4K",
            "feature_desc1": "Printklar kvalitet: Skal du printe et lille billede? Opskalér det til 4K eller 8K uden kvalitetstab. Perfekt til plakater, e-handels-produktfotos og baggrunde.",
            "feature_title2": "Smart Støjfjernelse & Afsløring",
            "feature_desc2": "Ret natfotos: Fjern digital støj og korn fra fotos taget i svagt lys. Skærp slørede kanter øjeblikkeligt for skarpe og professionelle resultater.",
            "feature_title3": "Restaurering af Gamle Fotos",
            "feature_desc3": "Genskab minder: Har du gamle, beskadigede eller sort-hvide fotos? Vores AI skaber nye pixels for at reparere ridser, skærpe ansigter og bringe klarhed tilbage til dine minder.",
            "howto": {
                "name": "Sådan opskalerer du et billede til 4K",
                "step1": {
                    "name": "Upload foto",
                    "text": "Upload dit slørede billede eller billede i lav opløsning til WeryAI Upscaler."
                },
                "step2": {
                    "name": "Vælg skala",
                    "text": "Vælg din ønskede opskaleringsfaktor (f.eks. 2x, 4x)."
                },
                "step3": {
                    "name": "Forbedr",
                    "text": "Klik på 'Opret'. AI'en vil behandle billedet og øjeblikkeligt forbedre opløsning og klarhed."
                }
            }
        }
    },
    "no": {
        "imageUpscaler": {
            "title": "Gratis AI Bildeforstørrer - Opp til 4K | WeryAI",
            "description": "Oppskaler bilder med lav oppløsning til 2x, 4x eller 4K med AI. Fiks uskarpe bilder, fjern støy og restaurer gamle familiebilder. Gratis kreditter ved registrering, ingen kredittkort nødvendig.",
            "keywords": "AI bildeforstørrer, bildeoppskalerer, oppskaler bilde til 4K, fjern uskarphet, restaurer gamle bilder, fiks pikselet bilde, øk bildeoppløsning, WeryAI",
            "og_title": "Gratis AI Bildeforstørrer - Opp til 4K | WeryAI",
            "og_description": "Oppskaler bilder med lav oppløsning til 2x, 4x eller 4K med AI. Fiks uskarpe bilder, fjern støy og restaurer gamle familiebilder. Gratis kreditter ved registrering, ingen kredittkort nødvendig.",
            "twitter_title": "Gratis AI Bildeforstørrer - Opp til 4K | WeryAI",
            "twitter_description": "Oppskaler bilder med lav oppløsning til 2x, 4x eller 4K med AI. Fiks uskarpe bilder, fjern støy og restaurer gamle familiebilder. Gratis kreditter ved registrering, ingen kredittkort nødvendig.",
            "page": {
                "title1": "Gratis AI Bilde-Upscaler og Forbedrer",
                "title2": "Gjør pikselerte, uskarpe eller gamle bilder om til mesterverk i høy oppløsning. WeryAI bruker avansert AI for å øke oppløsningen med opptil 400% (4K), gjenoppretter tapte detaljer, fikser støy og restaurerer ansikter i gamle familieportretter.",
                "faq": [
                    {
                        "question": "Kan jeg oppskale bilder med lav oppløsning for utskrift?",
                        "answer": "Ja! WeryAI øker oppløsningen (pikselantall) opp til 4K, noe som gjør bildet egnet for høykvalitetsutskrift på plakater, lerret eller markedsføringsmateriale."
                    },
                    {
                        "question": "Hvordan fungerer AI-restaurering av gamle bilder?",
                        "answer": "AI analyserer skadede eller uskarpe deler av det gamle bildet og bruker deep learning til å forutsi og gjenoppbygge ansiktsdetaljer, teksturer og bakgrunner, og \"helbreder\" effektivt bildet."
                    },
                    {
                        "question": "Hvilke formater støttes?",
                        "answer": "Vi støtter vanlige formater som JPG, PNG og WEBP. Resultatet vil være en PNG eller JPG i høy kvalitet."
                    },
                    {
                        "question": "Fungerer det på anime/tegneserier?",
                        "answer": "Ja. Vår AI utmerker seg i oppskalering av anime og illustrasjoner (waifu2x-stil), og holder linjer skarpe og farger livlige uten artefakter."
                    },
                    {
                        "question": "Kan jeg bruke WeryAI AI Image Upscaler gratis?",
                        "answer": "Ja. Nye brukere får gratis kreditter ved registrering uten kredittkort. Du kan også tjene flere gratis kreditter gjennom daglig innsjekking, fullføre oppgaver og invitere venner, slik at du kan fortsette å bruke verktøyet uten forhåndsbetaling."
                    }
                ]
            },
            "faq": [
                {
                    "question": "Kan jeg oppskale bilder med lav oppløsning for utskrift?",
                    "answer": "Ja! WeryAI øker oppløsningen opp til 4K, noe som gjør bilder egnet for høykvalitetsutskrift."
                },
                {
                    "question": "Hvordan fungerer AI-restaurering av gamle bilder?",
                    "answer": "AI analyserer skadede områder og gjenoppbygger ansiktsdetaljer og teksturer med deep learning."
                },
                {
                    "question": "Fungerer det på anime?",
                    "answer": "Ja. Vår AI utmerker seg i oppskalering av anime og illustrasjoner, og holder linjer skarpe uten artefakter."
                }
            ],
            "feature_title1": "Tapsfri Oppskalering til 4K",
            "feature_desc1": "Utskriftsklar kvalitet: Trenger du å skrive ut et lite bilde? Oppskaler det til 4K eller 8K uten kvalitetstap. Perfekt for plakater, e-handels produktbilder og bakgrunnsbilder.",
            "feature_title2": "Smart Støyfjerning og Uskarphetsfiks",
            "feature_desc2": "Fiks nattbilder: Fjern digital støy og korn fra bilder tatt i dårlig lys. Skjerp uskarpe kanter umiddelbart for skarpe og profesjonelle resultater.",
            "feature_title3": "Restaurering av Gamle Bilder",
            "feature_desc3": "Gjenoppliv minner: Har du gamle, skadede eller svart-hvite bilder? Vår AI skaper nye piksler for å reparere riper, skjerpe ansikter og bringe klarhet tilbake til dine dyrebare minner.",
            "howto": {
                "name": "Hvordan oppskale et bilde til 4K",
                "step1": {
                    "name": "Last opp bilde",
                    "text": "Last opp ditt lavoppløselige eller uskarpe bilde til WeryAI Upscaler."
                },
                "step2": {
                    "name": "Velg skala",
                    "text": "Velg ønsket oppskaleringsfaktor (f.eks. 2x, 4x)."
                },
                "step3": {
                    "name": "Forbedre",
                    "text": "Klikk på 'Opprett'. AI-en vil behandle bildet og umiddelbart forbedre oppløsning og klarhet."
                }
            }
        }
    },
    "nl": {
        "imageUpscaler": {
            "title": "Gratis AI Beeldvergroter - Tot 4K | WeryAI",
            "description": "Vergroot afbeeldingen met lage resolutie naar 2x, 4x of 4K met AI. Herstel onscherpe foto's, verwijder ruis en restaureer oude foto's. Gratis credits bij aanmelding, geen creditcard nodig.",
            "keywords": "AI beeldvergroter, fotovergroter, afbeelding opschalen naar 4K, onscherpte verwijderen, oude foto's restaureren, gepixelde foto herstellen, beeldresolutie verhogen, WeryAI",
            "og_title": "Gratis AI Beeldvergroter - Tot 4K | WeryAI",
            "og_description": "Vergroot afbeeldingen met lage resolutie naar 2x, 4x of 4K met AI. Herstel onscherpe foto's, verwijder ruis en restaureer oude foto's. Gratis credits bij aanmelding, geen creditcard nodig.",
            "twitter_title": "Gratis AI Beeldvergroter - Tot 4K | WeryAI",
            "twitter_description": "Vergroot afbeeldingen met lage resolutie naar 2x, 4x of 4K met AI. Herstel onscherpe foto's, verwijder ruis en restaureer oude foto's. Gratis credits bij aanmelding, geen creditcard nodig.",
            "page": {
                "title1": "Gratis AI Beeld-Upscaler en Verbeteraar",
                "title2": "Verander gepixelde, onscherpe of oude foto's in meesterwerken van hoge kwaliteit. WeryAI gebruikt geavanceerde AI om de resolutie tot 400% (4K) te verhogen, verloren details te herstellen, ruis te corrigeren en gezichten in oude familieportretten te restaureren.",
                "faq": [
                    {
                        "question": "Kan ik afbeeldingen met lage resolutie opschalen om te printen?",
                        "answer": "Ja! WeryAI verhoogt de resolutie (pixelaantal) tot 4K, waardoor de afbeelding geschikt is voor afdrukken van hoge kwaliteit op posters, canvas of marketingmateriaal."
                    },
                    {
                        "question": "Hoe werkt AI-restauratie van oude foto's?",
                        "answer": "De AI analyseert beschadigde of onscherpe delen van de oude foto en gebruikt deep learning om gezichtsdetails, texturen en achtergronden te voorspellen en te reconstrueren, waardoor het beeld effectief wordt \"genezen\"."
                    },
                    {
                        "question": "Welke formaten worden ondersteund?",
                        "answer": "We ondersteunen gangbare formaten zoals JPG, PNG en WEBP. De uitvoer is een PNG of JPG van hoge kwaliteit."
                    },
                    {
                        "question": "Werkt het voor anime/cartoons?",
                        "answer": "Ja. Onze AI blinkt uit in het opschalen van anime en illustraties (waifu2x-stijl), met scherpe lijnen en levendige kleuren zonder artefacten."
                    },
                    {
                        "question": "Kan ik WeryAI AI Image Upscaler gratis gebruiken?",
                        "answer": "Ja. Nieuwe gebruikers krijgen gratis credits bij aanmelding zonder creditcard. Je kunt ook meer gratis credits verdienen via dagelijkse check-in, taken voltooien en vrienden uitnodigen, zodat je de tool kunt blijven gebruiken zonder voorafbetaling."
                    }
                ]
            },
            "faq": [
                {
                    "question": "Kan ik afbeeldingen met lage resolutie opschalen om te printen?",
                    "answer": "Ja! WeryAI verhoogt de resolutie tot 4K, waardoor afbeeldingen geschikt zijn voor afdrukken van hoge kwaliteit."
                },
                {
                    "question": "Hoe werkt AI-restauratie van oude foto's?",
                    "answer": "De AI analyseert beschadigde gebieden en reconstrueert gezichtsdetails en texturen met deep learning."
                },
                {
                    "question": "Werkt het voor anime?",
                    "answer": "Ja. Onze AI blinkt uit in het opschalen van anime en illustraties, met scherpe lijnen zonder artefacten."
                }
            ],
            "feature_title1": "Verliesloze Opschaling tot 4K",
            "feature_desc1": "Printklare kwaliteit: Moet je een kleine afbeelding afdrukken? Schaal op naar 4K of 8K zonder kwaliteitsverlies. Perfect voor posters, e-commerce productfoto's en achtergronden.",
            "feature_title2": "Slimme Ruisonderdrukking en Onscherptefix",
            "feature_desc2": "Herstel nachtfoto's: Verwijder digitale ruis en korrel uit foto's bij weinig licht. Verscherp onscherpe randen direct voor heldere en professionele resultaten.",
            "feature_title3": "Restauratie van Oude Foto's",
            "feature_desc3": "Herleef herinneringen: Heb je oude, beschadigde of zwart-wit foto's? Onze AI creëert nieuwe pixels om krassen te repareren, gezichten te verscherpen en helderheid terug te brengen in je dierbare herinneringen.",
            "howto": {
                "name": "Hoe een afbeelding op te schalen naar 4K",
                "step1": {
                    "name": "Upload foto",
                    "text": "Upload je lage resolutie of onscherpe afbeelding naar WeryAI Upscaler."
                },
                "step2": {
                    "name": "Selecteer schaal",
                    "text": "Kies de gewenste opschalingsfactor (bijv. 2x, 4x)."
                },
                "step3": {
                    "name": "Verbeteren",
                    "text": "Klik op 'Maken'. De AI verwerkt de afbeelding en verbetert direct de resolutie en helderheid."
                }
            }
        }
    },
    "id": {
        "imageUpscaler": {
            "title": "Perbesar Gambar AI Gratis - Hingga 4K | WeryAI",
            "description": "Perbesar gambar resolusi rendah ke 2x, 4x, atau 4K dengan AI. Perbaiki foto buram, hilangkan noise, dan pulihkan foto lama. Kredit gratis saat mendaftar, tanpa kartu kredit.",
            "keywords": "AI perbesar gambar, peningkat foto, perbesar gambar ke 4K, perbaiki foto buram, pulihkan foto lama, perbaiki foto pecah, tingkatkan resolusi gambar, WeryAI",
            "og_title": "Perbesar Gambar AI Gratis - Hingga 4K | WeryAI",
            "og_description": "Perbesar gambar resolusi rendah ke 2x, 4x, atau 4K dengan AI. Perbaiki foto buram, hilangkan noise, dan pulihkan foto lama. Kredit gratis saat mendaftar, tanpa kartu kredit.",
            "twitter_title": "Perbesar Gambar AI Gratis - Hingga 4K | WeryAI",
            "twitter_description": "Perbesar gambar resolusi rendah ke 2x, 4x, atau 4K dengan AI. Perbaiki foto buram, hilangkan noise, dan pulihkan foto lama. Kredit gratis saat mendaftar, tanpa kartu kredit.",
            "page": {
                "title1": "Alat Perbesar & Peningkat Gambar AI Gratis",
                "title2": "Ubah foto pecah-pecah, buram, atau lama menjadi karya berkualitas tinggi. WeryAI menggunakan AI canggih untuk meningkatkan resolusi hingga 400% (4K), memulihkan detail yang hilang, memperbaiki noise, dan merestorasi wajah pada potret keluarga lama.",
                "faq": [
                    {
                        "question": "Bisakah saya memperbesar gambar resolusi rendah untuk dicetak?",
                        "answer": "Bisa! WeryAI meningkatkan resolusi (jumlah piksel) hingga 4K, membuatnya cocok untuk cetak berkualitas tinggi pada poster, kanvas, atau materi pemasaran."
                    },
                    {
                        "question": "Bagaimana cara kerja AI restorasi foto lama?",
                        "answer": "AI menganalisis bagian yang rusak atau buram dari foto lama dan menggunakan deep learning untuk memprediksi dan merekonstruksi detail wajah, tekstur, dan latar belakang, secara efektif \"menyembuhkan\" gambar."
                    },
                    {
                        "question": "Format apa saja yang didukung?",
                        "answer": "Kami mendukung format umum seperti JPG, PNG, dan WEBP. Hasilnya berupa PNG atau JPG berkualitas tinggi."
                    },
                    {
                        "question": "Apakah bisa untuk anime/kartun?",
                        "answer": "Bisa. AI kami unggul dalam memperbesar anime dan ilustrasi (gaya waifu2x), menjaga garis tajam dan warna cerah tanpa artefak."
                    },
                    {
                        "question": "Bisakah saya menggunakan WeryAI AI Image Upscaler secara gratis?",
                        "answer": "Bisa. Pengguna baru mendapat kredit gratis saat mendaftar tanpa kartu kredit. Anda juga bisa mendapatkan lebih banyak kredit gratis melalui check-in harian, menyelesaikan tugas, dan mengundang teman, sehingga bisa terus menggunakan alat ini tanpa pembayaran di muka."
                    }
                ]
            },
            "faq": [
                {
                    "question": "Bisakah saya memperbesar gambar resolusi rendah untuk dicetak?",
                    "answer": "Bisa! WeryAI meningkatkan resolusi hingga 4K, membuat gambar cocok untuk cetak berkualitas tinggi."
                },
                {
                    "question": "Bagaimana cara kerja AI restorasi foto lama?",
                    "answer": "AI menganalisis area yang rusak dan merekonstruksi detail wajah serta tekstur dengan deep learning."
                },
                {
                    "question": "Apakah bisa untuk anime?",
                    "answer": "Bisa. AI kami unggul dalam memperbesar anime dan ilustrasi, menjaga garis tajam tanpa artefak."
                }
            ],
            "feature_title1": "Pembesaran Tanpa Kehilangan hingga 4K",
            "feature_desc1": "Kualitas Siap Cetak: Perlu mencetak gambar kecil? Perbesar ke 4K atau 8K tanpa kehilangan kualitas. Sempurna untuk poster, foto produk e-commerce, dan wallpaper.",
            "feature_title2": "Pengurangan Noise & Blur Cerdas",
            "feature_desc2": "Perbaiki Foto Malam: Hapus noise digital dan grain dari foto cahaya rendah. Pertajam tepian buram secara instan agar foto terlihat jernih dan profesional.",
            "feature_title3": "Restorasi Foto Lama",
            "feature_desc3": "Hidupkan Kembali Kenangan: Punya foto lama, rusak, atau hitam putih? AI kami menciptakan piksel baru untuk memperbaiki goresan, mempertajam wajah, dan mengembalikan kejernihan pada kenangan berharga Anda.",
            "howto": {
                "name": "Cara Memperbesar Gambar ke 4K",
                "step1": {
                    "name": "Unggah Foto",
                    "text": "Unggah gambar beresolusi rendah atau buram Anda ke WeryAI Upscaler."
                },
                "step2": {
                    "name": "Pilih Skala",
                    "text": "Pilih faktor pembesaran yang Anda inginkan (misalnya 2x, 4x)."
                },
                "step3": {
                    "name": "Tingkatkan",
                    "text": "Klik 'Buat'. AI akan memproses gambar, langsung meningkatkan resolusi dan kejernihan."
                }
            }
        }
    },
    "tr": {
        "imageUpscaler": {
            "title": "Ücretsiz AI Görüntü Büyütücü - 4K'ya Kadar | WeryAI",
            "description": "Düşük çözünürlüklü görüntüleri AI ile 2x, 4x veya 4K'ya yükseltin. Bulanık fotoğrafları düzeltin, gürültüyü giderin ve eski fotoğrafları restore edin. Kayıtta ücretsiz kredi, kredi kartı gerekmez.",
            "keywords": "AI görüntü büyütücü, fotoğraf iyileştirici, görüntüyü 4K'ya yükselt, bulanıklığı gider, eski fotoğrafları restore et, piksellenmiş fotoğrafı düzelt, görüntü çözünürlüğünü artır, WeryAI",
            "og_title": "Ücretsiz AI Görüntü Büyütücü - 4K'ya Kadar | WeryAI",
            "og_description": "Düşük çözünürlüklü görüntüleri AI ile 2x, 4x veya 4K'ya yükseltin. Bulanık fotoğrafları düzeltin, gürültüyü giderin ve eski fotoğrafları restore edin. Kayıtta ücretsiz kredi, kredi kartı gerekmez.",
            "twitter_title": "Ücretsiz AI Görüntü Büyütücü - 4K'ya Kadar | WeryAI",
            "twitter_description": "Düşük çözünürlüklü görüntüleri AI ile 2x, 4x veya 4K'ya yükseltin. Bulanık fotoğrafları düzeltin, gürültüyü giderin ve eski fotoğrafları restore edin. Kayıtta ücretsiz kredi, kredi kartı gerekmez.",
            "page": {
                "title1": "Ücretsiz AI Görüntü Büyütücü ve İyileştirici",
                "title2": "Piksellenmiş, bulanık veya eski fotoğrafları yüksek çözünürlüklü başyapıtlara dönüştürün. WeryAI, gelişmiş AI kullanarak çözünürlüğü %400'e (4K) kadar artırır, kayıp detayları geri kazanır, gürültüyü düzeltir ve eski aile portrelerindeki yüzleri restore eder.",
                "faq": [
                    {
                        "question": "Düşük çözünürlüklü görüntüleri baskı için büyütebilir miyim?",
                        "answer": "Evet! WeryAI, görüntünüzün çözünürlüğünü (piksel sayısını) 4K'ya kadar artırarak poster, tuval veya pazarlama materyalleri üzerinde yüksek kaliteli baskıya uygun hale getirir."
                    },
                    {
                        "question": "AI eski fotoğraf restorasyonu nasıl çalışır?",
                        "answer": "AI, eski fotoğrafın hasarlı veya bulanık kısımlarını analiz eder ve yüz detaylarını, dokuları ve arka planları tahmin edip yeniden oluşturmak için derin öğrenme kullanır ve görüntüyü etkili bir şekilde \"iyileştirir\"."
                    },
                    {
                        "question": "Hangi formatlar desteklenir?",
                        "answer": "JPG, PNG ve WEBP gibi yaygın formatları destekliyoruz. Çıktı yüksek kaliteli PNG veya JPG olacaktır."
                    },
                    {
                        "question": "Anime/çizgi filmler için çalışır mı?",
                        "answer": "Evet. AI'mız anime ve illüstrasyonları (waifu2x tarzı) büyütmede mükemmeldir, çizgileri keskin ve renkleri canlı tutar, artefakt oluşmaz."
                    },
                    {
                        "question": "WeryAI AI Image Upscaler'ı ücretsiz kullanabilir miyim?",
                        "answer": "Evet. Yeni kullanıcılar kayıt olduklarında kredi kartı gerekmeden ücretsiz kredi alır. Ayrıca günlük giriş, görev tamamlama ve arkadaş davet etme yoluyla daha fazla ücretsiz kredi kazanabilirsiniz, böylece ön ödeme yapmadan aracı kullanmaya devam edebilirsiniz."
                    }
                ]
            },
            "faq": [
                {
                    "question": "Düşük çözünürlüklü görüntüleri baskı için büyütebilir miyim?",
                    "answer": "Evet! WeryAI çözünürlüğü 4K'ya kadar artırarak görüntüleri yüksek kaliteli baskıya uygun hale getirir."
                },
                {
                    "question": "AI eski fotoğraf restorasyonu nasıl çalışır?",
                    "answer": "AI hasarlı alanları analiz eder ve derin öğrenme ile yüz detaylarını ve dokuları yeniden oluşturur."
                },
                {
                    "question": "Anime için çalışır mı?",
                    "answer": "Evet. AI'mız anime ve illüstrasyonları büyütmede mükemmeldir, çizgileri keskin tutar, artefakt oluşmaz."
                }
            ],
            "feature_title1": "Kayıpsız 4K Büyütme",
            "feature_desc1": "Baskıya hazır kalite: Küçük bir görüntüyü yazdırmanız mı gerekiyor? Kalite kaybı olmadan 4K veya 8K'ya büyütün. Posterler, e-ticaret ürün fotoğrafları ve duvar kağıtları için mükemmel.",
            "feature_title2": "Akıllı Gürültü Giderme ve Bulanıklık Düzeltme",
            "feature_desc2": "Gece fotoğraflarını düzeltin: Düşük ışıklı fotoğraflardan dijital gürültüyü ve grenı kaldırın. Bulanık kenarları anında keskinleştirerek fotoğraflarınızın net ve profesyonel görünmesini sağlayın.",
            "feature_title3": "Eski Fotoğraf Restorasyonu",
            "feature_desc3": "Anıları canlandırın: Eski, hasarlı veya siyah beyaz fotoğraflarınız mı var? AI'mız çizikleri onarmak, yüzleri keskinleştirmek ve değerli anılarınıza netlik kazandırmak için yeni pikseller oluşturur.",
            "howto": {
                "name": "Görüntüyü 4K'ya Nasıl Büyütülür",
                "step1": {
                    "name": "Fotoğraf Yükle",
                    "text": "Düşük çözünürlüklü veya bulanık görüntünüzü WeryAI Upscaler'a yükleyin."
                },
                "step2": {
                    "name": "Ölçek Seç",
                    "text": "İstediğiniz büyütme faktörünü seçin (ör. 2x, 4x)."
                },
                "step3": {
                    "name": "İyileştir",
                    "text": "'Oluştur'a tıklayın. AI görüntüyü işleyerek çözünürlüğü ve netliği anında artıracaktır."
                }
            }
        }
    }
}
